"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountTarget = exports.DiscountRuleSubsidyTarget = exports.DiscountRuleStatus = exports.Direction = exports.DeliveryWindowLocation = exports.DeliveryWindowComponentSource = exports.DeliveryOptionCostDetailSource = exports.DeliveryOptionCostDetailComponentKey = exports.DeliveredDutyDisplayType = exports.DeliveredDuty = exports.DayOfWeek = exports.CvvResultCode = exports.CvvCode = exports.CustomerAddressType = exports.CurrencySymbolFormat = exports.CurrencyLabelFormatter = exports.CreditPaymentErrorCode = exports.CountryPickerSource = exports.CostEstimateSource = exports.ConsumerInvoiceStatus = exports.ConsumerInvoiceDocumentType = exports.ConsumerInvoiceCustomerType = exports.ChannelShopifyOrderStateReasonCode = exports.ChannelCurrencyCapability = exports.ChangeType = exports.CenterCapability = exports.CarrierChargeReason = exports.CardType = exports.CardErrorCode = exports.CaptureStatus = exports.CaptureDeclineCode = exports.Capability = exports.CancelReason = exports.Calendar = exports.B2BInvoiceType = exports.AvsCode = exports.AvailableFilterFormat = exports.AvailabilityStatus = exports.AuthorizationStatus = exports.AuthorizationResultActionType = exports.AuthorizationOption = exports.AuthorizationDeclineCode = exports.AuthenticationTechnique = exports.AttributeIntent = exports.AttributeDataType = exports.AdjustmentReasonKey = exports.AddressVerificationResultFieldCode = exports.AddressFieldName = exports.AbandonedOrderSettingStatus = exports.AbandonedOrderPromotionStatus = void 0;
exports.MeasurementSystem = exports.MarginType = exports.LogisticsFormatPreference = exports.LocationErrorCode = exports.LevyStrategy = exports.LevyComponent = exports.LaneStrategy = exports.LanePreselectPreference = exports.LaneDirection = exports.LabelTriggerMethod = exports.LabelRequestMethod = exports.ItemIdentifier = exports.ItemAvailabilityStatus = exports.InvitationErrorCode = exports.InputSpecificationType = exports.InlineWindowViewportSize = exports.IncotermConfiguration = exports.Incoterm = exports.IncludedLevyKey = exports.ImportType = exports.ImageTag = exports.HolidayCalendar = exports.GoodsSupply = exports.GenericErrorCode = exports.FulfillmentRouting = exports.FulfillmentMethodValue = exports.FulfillmentMethodType = exports.FulfillmentItemQuantityStatus = exports.FtpFileSource = exports.FraudStatus = exports.FraudLiability = exports.FraudEmailRuleDecision = exports.FlowRole = exports.FlowEntity = exports.FlowBehavior = exports.FeeDeductionType = exports.ExporterOfRecord = exports.ExportStatus = exports.ExperienceStatus = exports.ExperiencePaymentMethodTag = exports.ExperienceCountryStatus = exports.ExperienceCloneStatus = exports.ExclusionRuleState = exports.ExceptionType = exports.EventType = exports.Environment = exports.EntityIdentifierType = exports.EconomicTitleLocation = exports.EcommercePlatformType = exports.DutyItemApprovalStatus = void 0;
exports.PriceDetailKey = exports.PriceDetailComponentKey = exports.PriceBookStatus = exports.PriceAccuracy = exports.PreferredServiceSelectionStrategy = exports.PostalType = exports.PhysicalDeliverySpecialSerivce = exports.PermittedHttpMethod = exports.PendingPayoutTransactionReasonCode = exports.PayoutStatusFailureCode = exports.PayoutAttachmentType = exports.PaymentType = exports.PaymentStatus = exports.PaymentSourceConfirmationActionType = exports.PaymentRequestReviewStatus = exports.PaymentRequestReviewCheckType = exports.PaymentRequestReviewCheckStatus = exports.PaymentMethodType = exports.PaymentMethodRuleContentKey = exports.PaymentMethodDataOptionType = exports.PaymentMethodCapability = exports.PaymentFailureCode = exports.PaymentErrorCode = exports.PaymentActionType = exports.PackageDimensionsSource = exports.OriginLocationSource = exports.OrganizationType = exports.OrganizationStatus = exports.OrganizationPaymentMethodTag = exports.OrderType = exports.OrderStorage = exports.OrderStatus = exports.OrderRefundSummaryPartialCharged = exports.OrderRefundSummaryIncludes = exports.OrderPriceDetailKey = exports.OrderPriceDetailComponentKey = exports.OrderPaymentType = exports.OrderPaymentSourceType = exports.OrderMerchantOfRecord = exports.OrderErrorCode = exports.OrderChangeSource = exports.OptinResponseType = exports.OnboardingTradeSector = exports.OnboardingBlockedReason = exports.OnboardingApplicationStatus = exports.Method = exports.MerchantRejectedReason = exports.MerchantOfRecord = exports.MerchantGiftCardErrorCode = exports.MerchantDisabledReason = void 0;
exports.TrackingStatus = exports.TrackingNumberType = exports.TokenType = exports.TierStrategy = exports.TierEstimateType = exports.TierAvailability = exports.ThreedsTwoChallengeViewport = exports.ThreeDSecureCode = exports.TaxabilityValue = exports.TaxabilityType = exports.TaxVerificationResult = exports.TaxReportType = exports.TaxApplicability = exports.SurchargeResponsibleParty = exports.SubstatusCode = exports.SubcatalogItemStatus = exports.Strategy = exports.StoredMethodUsageStep = exports.StatementAttachmentType = exports.SortDirection = exports.ShopifySyncCheck = exports.ShopifyLocalizationMethod = exports.ShopifyGrant = exports.ShippingLabelErrorCode = exports.ShippingConfigurationType = exports.ShipmentRecipient = exports.ShipmentIntegrationType = exports.ScheduleExceptionStatus = exports.RoundingType = exports.RoundingMethod = exports.Role = exports.ReviewStatus = exports.ReversalStatus = exports.ReversalErrorCode = exports.ReturnTrackingStatus = exports.ReturnStatus = exports.ReturnPolicyState = exports.ReturnItemStatus = exports.RestrictedReviewStatus = exports.RegionType = exports.RefundStatus = exports.RefundFailureCategory = exports.RefundDeclineCode = exports.RatecardOwner = exports.QuoteErrorCode = exports.ProvinceType = exports.PromotionTriggerType = exports.ProductRestrictionRule = exports.PricingLevySetting = exports.PriceFacetBoundary = void 0;
exports.ZeroAmountIndicator = exports.WithholdingDeductionType = exports.WebhookStatus = exports.Visibility = exports.ValueAddedService = exports.UserStatus = exports.UpdatePolicy = exports.UnitOfWeight = exports.UnitOfVolume = exports.UnitOfTime = exports.UnitOfMeasurement = exports.UnitOfLength = exports.TrueupSurchargeType = exports.TrueupSource = exports.TransactionSource = exports.TradeAgreementStatus = exports.TradeAgreementName = void 0;
var AbandonedOrderPromotionStatus;
(function (AbandonedOrderPromotionStatus) {
    AbandonedOrderPromotionStatus["ACTIVE"] = "active";
    AbandonedOrderPromotionStatus["INACTIVE"] = "inactive";
})(AbandonedOrderPromotionStatus = exports.AbandonedOrderPromotionStatus || (exports.AbandonedOrderPromotionStatus = {}));
var AbandonedOrderSettingStatus;
(function (AbandonedOrderSettingStatus) {
    AbandonedOrderSettingStatus["ACTIVE"] = "active";
    AbandonedOrderSettingStatus["INACTIVE"] = "inactive";
})(AbandonedOrderSettingStatus = exports.AbandonedOrderSettingStatus || (exports.AbandonedOrderSettingStatus = {}));
var AddressFieldName;
(function (AddressFieldName) {
    AddressFieldName["FIRST_NAME"] = "first_name";
    AddressFieldName["LAST_NAME"] = "last_name";
    AddressFieldName["STREET_1"] = "street_1";
    AddressFieldName["STREET_2"] = "street_2";
    AddressFieldName["CITY"] = "city";
    AddressFieldName["PROVINCE"] = "province";
    AddressFieldName["POSTAL"] = "postal";
    AddressFieldName["COUNTRY"] = "country";
    AddressFieldName["PHONE"] = "phone";
    AddressFieldName["COMPANY"] = "company";
    AddressFieldName["VAT_REGISTRATION_NUMBER"] = "vat_registration_number";
})(AddressFieldName = exports.AddressFieldName || (exports.AddressFieldName = {}));
var AddressVerificationResultFieldCode;
(function (AddressVerificationResultFieldCode) {
    AddressVerificationResultFieldCode["MATCHED"] = "matched";
    AddressVerificationResultFieldCode["NOT_AVAILABLE"] = "not_available";
    AddressVerificationResultFieldCode["NOT_CHECKED"] = "not_checked";
    AddressVerificationResultFieldCode["NOT_MATCHED"] = "not_matched";
})(AddressVerificationResultFieldCode = exports.AddressVerificationResultFieldCode || (exports.AddressVerificationResultFieldCode = {}));
var AdjustmentReasonKey;
(function (AdjustmentReasonKey) {
    AdjustmentReasonKey["DUTY_DEMINIMIS"] = "duty_deminimis";
    AdjustmentReasonKey["VAT_DEMINIMIS"] = "vat_deminimis";
})(AdjustmentReasonKey = exports.AdjustmentReasonKey || (exports.AdjustmentReasonKey = {}));
var AttributeDataType;
(function (AttributeDataType) {
    AttributeDataType["BOOLEAN"] = "boolean";
    AttributeDataType["INTEGER"] = "integer";
    AttributeDataType["DECIMAL"] = "decimal";
    AttributeDataType["STRING"] = "string";
    AttributeDataType["JSON_ARRAY"] = "json_array";
})(AttributeDataType = exports.AttributeDataType || (exports.AttributeDataType = {}));
var AttributeIntent;
(function (AttributeIntent) {
    AttributeIntent["BRAND"] = "brand";
    AttributeIntent["COLOR"] = "color";
    AttributeIntent["COUNTRIES_OF_ORIGIN"] = "countries_of_origin";
    AttributeIntent["PRODUCT_ID"] = "product_id";
    AttributeIntent["FULFILLMENT_METHOD"] = "fulfillment_method";
    AttributeIntent["HAZARDOUS"] = "hazardous";
    AttributeIntent["PRICE"] = "price";
    AttributeIntent["SIZE"] = "size";
    AttributeIntent["SKU"] = "sku";
    AttributeIntent["TAXABILITY"] = "taxability";
    AttributeIntent["CONSUMER_URL"] = "consumer_url";
    AttributeIntent["GTIN"] = "gtin";
    AttributeIntent["MPN"] = "mpn";
    AttributeIntent["FACET"] = "facet";
    AttributeIntent["ECCN"] = "eccn";
    AttributeIntent["RETURNABLE"] = "returnable";
    AttributeIntent["SEARCHABLE"] = "searchable";
    AttributeIntent["BARCODE"] = "barcode";
    AttributeIntent["MIN_DAYS_TO_SHIP"] = "min_days_to_ship";
    AttributeIntent["MAX_DAYS_TO_SHIP"] = "max_days_to_ship";
    AttributeIntent["COMMERCIAL_INVOICE_ITEM_NUMBER"] = "commercial_invoice_item_number";
    AttributeIntent["INCLUDE_IN_PRODUCT_FEEDS"] = "include_in_product_feeds";
})(AttributeIntent = exports.AttributeIntent || (exports.AttributeIntent = {}));
var AuthenticationTechnique;
(function (AuthenticationTechnique) {
    AuthenticationTechnique["ANONYMOUS"] = "anonymous";
    AuthenticationTechnique["SESSION"] = "session";
    AuthenticationTechnique["TOKEN"] = "token";
    AuthenticationTechnique["PARTNER_TOKEN"] = "partner_token";
    AuthenticationTechnique["USER"] = "user";
})(AuthenticationTechnique = exports.AuthenticationTechnique || (exports.AuthenticationTechnique = {}));
var AuthorizationDeclineCode;
(function (AuthorizationDeclineCode) {
    AuthorizationDeclineCode["EXPIRED"] = "expired";
    AuthorizationDeclineCode["INVALID_NAME"] = "invalid_name";
    AuthorizationDeclineCode["INVALID_NUMBER"] = "invalid_number";
    AuthorizationDeclineCode["INVALID_EXPIRATION"] = "invalid_expiration";
    AuthorizationDeclineCode["INVALID_ADDRESS"] = "invalid_address";
    AuthorizationDeclineCode["INVALID_TOKEN_TYPE"] = "invalid_token_type";
    AuthorizationDeclineCode["INVALID_TOKEN"] = "invalid_token";
    AuthorizationDeclineCode["NO_ACCOUNT"] = "no_account";
    AuthorizationDeclineCode["AVS"] = "avs";
    AuthorizationDeclineCode["CVV"] = "cvv";
    AuthorizationDeclineCode["FRAUD"] = "fraud";
    AuthorizationDeclineCode["DUPLICATE"] = "duplicate";
    AuthorizationDeclineCode["NOT_SUPPORTED"] = "not_supported";
    AuthorizationDeclineCode["UNKNOWN"] = "unknown";
    AuthorizationDeclineCode["ONLINE_PAYMENT_ERROR"] = "online_payment_error";
})(AuthorizationDeclineCode = exports.AuthorizationDeclineCode || (exports.AuthorizationDeclineCode = {}));
var AuthorizationOption;
(function (AuthorizationOption) {
    AuthorizationOption["STORE_CARD"] = "store_card";
})(AuthorizationOption = exports.AuthorizationOption || (exports.AuthorizationOption = {}));
var AuthorizationResultActionType;
(function (AuthorizationResultActionType) {
    AuthorizationResultActionType["NATIVE"] = "native";
    AuthorizationResultActionType["REDIRECT"] = "redirect";
    AuthorizationResultActionType["WAIT"] = "wait";
})(AuthorizationResultActionType = exports.AuthorizationResultActionType || (exports.AuthorizationResultActionType = {}));
var AuthorizationStatus;
(function (AuthorizationStatus) {
    AuthorizationStatus["INITIATED"] = "initiated";
    AuthorizationStatus["PENDING"] = "pending";
    AuthorizationStatus["EXPIRED"] = "expired";
    AuthorizationStatus["AUTHORIZED"] = "authorized";
    AuthorizationStatus["REVIEW"] = "review";
    AuthorizationStatus["DECLINED"] = "declined";
    AuthorizationStatus["REVERSED"] = "reversed";
})(AuthorizationStatus = exports.AuthorizationStatus || (exports.AuthorizationStatus = {}));
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["ENABLED"] = "enabled";
    AvailabilityStatus["DISABLED"] = "disabled";
})(AvailabilityStatus = exports.AvailabilityStatus || (exports.AvailabilityStatus = {}));
var AvailableFilterFormat;
(function (AvailableFilterFormat) {
    AvailableFilterFormat["BOOLEAN"] = "boolean";
    AvailableFilterFormat["DATE"] = "date";
    AvailableFilterFormat["MONEY"] = "money";
    AvailableFilterFormat["DECIMAL"] = "decimal";
    AvailableFilterFormat["STRING"] = "string";
    AvailableFilterFormat["UNIT_OF_LENGTH"] = "unit_of_length";
    AvailableFilterFormat["UNIT_OF_MASS"] = "unit_of_mass";
})(AvailableFilterFormat = exports.AvailableFilterFormat || (exports.AvailableFilterFormat = {}));
var AvsCode;
(function (AvsCode) {
    AvsCode["MATCH"] = "match";
    AvsCode["PARTIAL"] = "partial";
    AvsCode["UNSUPPORTED"] = "unsupported";
    AvsCode["NO_MATCH"] = "no_match";
})(AvsCode = exports.AvsCode || (exports.AvsCode = {}));
var B2BInvoiceType;
(function (B2BInvoiceType) {
    B2BInvoiceType["SELF_BILL_INVOICE"] = "self_bill_invoice";
    B2BInvoiceType["INVOICE"] = "invoice";
})(B2BInvoiceType = exports.B2BInvoiceType || (exports.B2BInvoiceType = {}));
var Calendar;
(function (Calendar) {
    Calendar["WEEKDAYS"] = "weekdays";
    Calendar["EVERYDAY"] = "everyday";
})(Calendar = exports.Calendar || (exports.Calendar = {}));
var CancelReason;
(function (CancelReason) {
    CancelReason["OUT_OF_STOCK"] = "out_of_stock";
    CancelReason["CONSUMER_REQUESTED"] = "consumer_requested";
    CancelReason["FLOW_CANCEL"] = "flow_cancel";
})(CancelReason = exports.CancelReason || (exports.CancelReason = {}));
var Capability;
(function (Capability) {
    Capability["CROSSDOCK"] = "crossdock";
})(Capability = exports.Capability || (exports.Capability = {}));
var CaptureDeclineCode;
(function (CaptureDeclineCode) {
    CaptureDeclineCode["EXPIRED"] = "expired";
    CaptureDeclineCode["INSUFFICIENT_FUNDS"] = "insufficient_funds";
    CaptureDeclineCode["UNKNOWN"] = "unknown";
})(CaptureDeclineCode = exports.CaptureDeclineCode || (exports.CaptureDeclineCode = {}));
var CaptureStatus;
(function (CaptureStatus) {
    CaptureStatus["INITIATED"] = "initiated";
    CaptureStatus["PENDING"] = "pending";
    CaptureStatus["SUCCEEDED"] = "succeeded";
    CaptureStatus["FAILED"] = "failed";
    CaptureStatus["CANCELED"] = "canceled";
})(CaptureStatus = exports.CaptureStatus || (exports.CaptureStatus = {}));
var CardErrorCode;
(function (CardErrorCode) {
    CardErrorCode["INVALID_ADDRESS"] = "invalid_address";
    CardErrorCode["INVALID_CURRENCY"] = "invalid_currency";
    CardErrorCode["INVALID_NAME"] = "invalid_name";
    CardErrorCode["INVALID_NUMBER"] = "invalid_number";
    CardErrorCode["INVALID_EXPIRATION"] = "invalid_expiration";
    CardErrorCode["INVALID_TOKEN_TYPE"] = "invalid_token_type";
    CardErrorCode["AVS"] = "avs";
    CardErrorCode["CVV"] = "cvv";
    CardErrorCode["FRAUD"] = "fraud";
    CardErrorCode["UNKNOWN"] = "unknown";
})(CardErrorCode = exports.CardErrorCode || (exports.CardErrorCode = {}));
var CardType;
(function (CardType) {
    CardType["AMERICAN_EXPRESS"] = "american_express";
    CardType["CARTES_BANCAIRES"] = "cartes_bancaires";
    CardType["CHINA_UNION_PAY"] = "china_union_pay";
    CardType["DANKORT"] = "dankort";
    CardType["DINERS_CLUB"] = "diners_club";
    CardType["DISCOVER"] = "discover";
    CardType["JCB"] = "jcb";
    CardType["MAESTRO"] = "maestro";
    CardType["MASTERCARD"] = "mastercard";
    CardType["VISA"] = "visa";
})(CardType = exports.CardType || (exports.CardType = {}));
var CarrierChargeReason;
(function (CarrierChargeReason) {
    CarrierChargeReason["RETURN_TO_ORIGIN"] = "return_to_origin";
    CarrierChargeReason["REJECTION"] = "rejection";
    CarrierChargeReason["OTHER"] = "other";
})(CarrierChargeReason = exports.CarrierChargeReason || (exports.CarrierChargeReason = {}));
var CenterCapability;
(function (CenterCapability) {
    CenterCapability["INTERNATIONAL"] = "international";
    CenterCapability["DOMESTIC"] = "domestic";
    CenterCapability["CROSSDOCK"] = "crossdock";
    CenterCapability["COMMERCIAL_INVOICE"] = "commercial_invoice";
})(CenterCapability = exports.CenterCapability || (exports.CenterCapability = {}));
var ChangeType;
(function (ChangeType) {
    ChangeType["INSERT"] = "insert";
    ChangeType["UPDATE"] = "update";
    ChangeType["DELETE"] = "delete";
})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
var ChannelCurrencyCapability;
(function (ChannelCurrencyCapability) {
    ChannelCurrencyCapability["PAYMENT_AUTHORIZATIONS"] = "payment_authorizations";
    ChannelCurrencyCapability["SETTLEMENT_CURRENCY"] = "settlement_currency";
})(ChannelCurrencyCapability = exports.ChannelCurrencyCapability || (exports.ChannelCurrencyCapability = {}));
var ChannelShopifyOrderStateReasonCode;
(function (ChannelShopifyOrderStateReasonCode) {
    ChannelShopifyOrderStateReasonCode["PLACEHOLDER_REASON_CODE"] = "placeholder_reason_code";
})(ChannelShopifyOrderStateReasonCode = exports.ChannelShopifyOrderStateReasonCode || (exports.ChannelShopifyOrderStateReasonCode = {}));
var ConsumerInvoiceCustomerType;
(function (ConsumerInvoiceCustomerType) {
    ConsumerInvoiceCustomerType["BUSINESS_EU_VERIFIED"] = "business_eu_verified";
    ConsumerInvoiceCustomerType["BUSINESS_NON_VERIFIED"] = "business_non_verified";
    ConsumerInvoiceCustomerType["INDIVIDUAL"] = "individual";
})(ConsumerInvoiceCustomerType = exports.ConsumerInvoiceCustomerType || (exports.ConsumerInvoiceCustomerType = {}));
var ConsumerInvoiceDocumentType;
(function (ConsumerInvoiceDocumentType) {
    ConsumerInvoiceDocumentType["PDF"] = "pdf";
})(ConsumerInvoiceDocumentType = exports.ConsumerInvoiceDocumentType || (exports.ConsumerInvoiceDocumentType = {}));
var ConsumerInvoiceStatus;
(function (ConsumerInvoiceStatus) {
    ConsumerInvoiceStatus["PENDING"] = "pending";
    ConsumerInvoiceStatus["AVAILABLE"] = "available";
    ConsumerInvoiceStatus["INVALID"] = "invalid";
})(ConsumerInvoiceStatus = exports.ConsumerInvoiceStatus || (exports.ConsumerInvoiceStatus = {}));
var CostEstimateSource;
(function (CostEstimateSource) {
    CostEstimateSource["FLOW"] = "flow";
    CostEstimateSource["CHANNEL"] = "channel";
})(CostEstimateSource = exports.CostEstimateSource || (exports.CostEstimateSource = {}));
var CountryPickerSource;
(function (CountryPickerSource) {
    CountryPickerSource["EXPERIENCE"] = "experience";
    CountryPickerSource["DESTINATION"] = "destination";
})(CountryPickerSource = exports.CountryPickerSource || (exports.CountryPickerSource = {}));
var CreditPaymentErrorCode;
(function (CreditPaymentErrorCode) {
    CreditPaymentErrorCode["GENERIC_ERROR"] = "generic_error";
    CreditPaymentErrorCode["INVALID_ORDER_NUMBER"] = "invalid_order_number";
    CreditPaymentErrorCode["INVALID_CURRENCY"] = "invalid_currency";
    CreditPaymentErrorCode["INVALID_DESCRIPTION"] = "invalid_description";
    CreditPaymentErrorCode["DUPLICATE"] = "duplicate";
    CreditPaymentErrorCode["AMOUNT_MUST_BE_POSITIVE"] = "amount_must_be_positive";
    CreditPaymentErrorCode["AMOUNT_EXCEEDS_BALANCE"] = "amount_exceeds_balance";
    CreditPaymentErrorCode["INSUFFICIENT_AMOUNT"] = "insufficient_amount";
})(CreditPaymentErrorCode = exports.CreditPaymentErrorCode || (exports.CreditPaymentErrorCode = {}));
var CurrencyLabelFormatter;
(function (CurrencyLabelFormatter) {
    CurrencyLabelFormatter["STRIP_TRAILING_ZEROS"] = "strip_trailing_zeros";
    CurrencyLabelFormatter["SYMBOL_PREFIX"] = "symbol_prefix";
    CurrencyLabelFormatter["SYMBOL_SUFFIX"] = "symbol_suffix";
})(CurrencyLabelFormatter = exports.CurrencyLabelFormatter || (exports.CurrencyLabelFormatter = {}));
var CurrencySymbolFormat;
(function (CurrencySymbolFormat) {
    CurrencySymbolFormat["NARROW"] = "narrow";
    CurrencySymbolFormat["PRIMARY"] = "primary";
})(CurrencySymbolFormat = exports.CurrencySymbolFormat || (exports.CurrencySymbolFormat = {}));
var CustomerAddressType;
(function (CustomerAddressType) {
    CustomerAddressType["BILLING"] = "billing";
    CustomerAddressType["INVOICE"] = "invoice";
    CustomerAddressType["SHIPPING"] = "shipping";
})(CustomerAddressType = exports.CustomerAddressType || (exports.CustomerAddressType = {}));
var CvvCode;
(function (CvvCode) {
    CvvCode["MATCH"] = "match";
    CvvCode["SUSPICIOUS"] = "suspicious";
    CvvCode["UNSUPPORTED"] = "unsupported";
    CvvCode["NO_MATCH"] = "no_match";
})(CvvCode = exports.CvvCode || (exports.CvvCode = {}));
var CvvResultCode;
(function (CvvResultCode) {
    CvvResultCode["MATCHED"] = "matched";
    CvvResultCode["NOT_AVAILABLE"] = "not_available";
    CvvResultCode["NOT_CHECKED"] = "not_checked";
    CvvResultCode["NOT_MATCHED"] = "not_matched";
})(CvvResultCode = exports.CvvResultCode || (exports.CvvResultCode = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["SUNDAY"] = "sunday";
    DayOfWeek["MONDAY"] = "monday";
    DayOfWeek["TUESDAY"] = "tuesday";
    DayOfWeek["WEDNESDAY"] = "wednesday";
    DayOfWeek["THURSDAY"] = "thursday";
    DayOfWeek["FRIDAY"] = "friday";
    DayOfWeek["SATURDAY"] = "saturday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var DeliveredDuty;
(function (DeliveredDuty) {
    DeliveredDuty["PAID"] = "paid";
    DeliveredDuty["UNPAID"] = "unpaid";
})(DeliveredDuty = exports.DeliveredDuty || (exports.DeliveredDuty = {}));
var DeliveredDutyDisplayType;
(function (DeliveredDutyDisplayType) {
    DeliveredDutyDisplayType["ALL"] = "all";
    DeliveredDutyDisplayType["SINGLE"] = "single";
})(DeliveredDutyDisplayType = exports.DeliveredDutyDisplayType || (exports.DeliveredDutyDisplayType = {}));
var DeliveryOptionCostDetailComponentKey;
(function (DeliveryOptionCostDetailComponentKey) {
    DeliveryOptionCostDetailComponentKey["RATECARD_BASE_COST"] = "ratecard_base_cost";
    DeliveryOptionCostDetailComponentKey["RATECARD_DDP_FEE"] = "ratecard_ddp_fee";
    DeliveryOptionCostDetailComponentKey["RATECARD_FUEL_SURCHARGE"] = "ratecard_fuel_surcharge";
    DeliveryOptionCostDetailComponentKey["RATECARD_OVERSIZED_SHIPMENT_FEE"] = "ratecard_oversized_shipment_fee";
    DeliveryOptionCostDetailComponentKey["RATECARD_RURAL_SHIPMENT_FEE"] = "ratecard_rural_shipment_fee";
    DeliveryOptionCostDetailComponentKey["RATECARD_EMERGENCY_SITUATION_SURCHARGE_FEE"] = "ratecard_emergency_situation_surcharge_fee";
    DeliveryOptionCostDetailComponentKey["RATECARD_PEAK_SURCHARGE_FEE"] = "ratecard_peak_surcharge_fee";
    DeliveryOptionCostDetailComponentKey["RATECARD_DUTIES_TAXES_PAID_SURCHARGE_FEE"] = "ratecard_duties_taxes_paid_surcharge_fee";
    DeliveryOptionCostDetailComponentKey["CENTER_COMMERCIAL_INVOICE_FEE"] = "center_commercial_invoice_fee";
    DeliveryOptionCostDetailComponentKey["CENTER_INBOUND_CARTON_FEE"] = "center_inbound_carton_fee";
    DeliveryOptionCostDetailComponentKey["CENTER_OUTBOUND_CARTON_FEE"] = "center_outbound_carton_fee";
})(DeliveryOptionCostDetailComponentKey = exports.DeliveryOptionCostDetailComponentKey || (exports.DeliveryOptionCostDetailComponentKey = {}));
var DeliveryOptionCostDetailSource;
(function (DeliveryOptionCostDetailSource) {
    DeliveryOptionCostDetailSource["CENTER"] = "center";
    DeliveryOptionCostDetailSource["RATECARD"] = "ratecard";
})(DeliveryOptionCostDetailSource = exports.DeliveryOptionCostDetailSource || (exports.DeliveryOptionCostDetailSource = {}));
var DeliveryWindowComponentSource;
(function (DeliveryWindowComponentSource) {
    DeliveryWindowComponentSource["FLOW"] = "flow";
    DeliveryWindowComponentSource["ORGANIZATION"] = "organization";
    DeliveryWindowComponentSource["CARRIER"] = "carrier";
    DeliveryWindowComponentSource["CENTER"] = "center";
    DeliveryWindowComponentSource["MIXED"] = "mixed";
})(DeliveryWindowComponentSource = exports.DeliveryWindowComponentSource || (exports.DeliveryWindowComponentSource = {}));
var DeliveryWindowLocation;
(function (DeliveryWindowLocation) {
    DeliveryWindowLocation["CENTER"] = "center";
    DeliveryWindowLocation["CROSSDOCK"] = "crossdock";
    DeliveryWindowLocation["CUSTOMER"] = "customer";
})(DeliveryWindowLocation = exports.DeliveryWindowLocation || (exports.DeliveryWindowLocation = {}));
var Direction;
(function (Direction) {
    Direction["OUTBOUND"] = "outbound";
    Direction["RETURN"] = "return";
})(Direction = exports.Direction || (exports.Direction = {}));
var DiscountRuleStatus;
(function (DiscountRuleStatus) {
    DiscountRuleStatus["ACTIVE"] = "active";
    DiscountRuleStatus["SCHEDULED"] = "scheduled";
    DiscountRuleStatus["EXPIRED"] = "expired";
})(DiscountRuleStatus = exports.DiscountRuleStatus || (exports.DiscountRuleStatus = {}));
var DiscountRuleSubsidyTarget;
(function (DiscountRuleSubsidyTarget) {
    DiscountRuleSubsidyTarget["VAT"] = "vat";
    DiscountRuleSubsidyTarget["DUTY"] = "duty";
})(DiscountRuleSubsidyTarget = exports.DiscountRuleSubsidyTarget || (exports.DiscountRuleSubsidyTarget = {}));
var DiscountTarget;
(function (DiscountTarget) {
    DiscountTarget["ITEM"] = "item";
    DiscountTarget["SHIPPING"] = "shipping";
})(DiscountTarget = exports.DiscountTarget || (exports.DiscountTarget = {}));
var DutyItemApprovalStatus;
(function (DutyItemApprovalStatus) {
    DutyItemApprovalStatus["PENDING"] = "pending";
    DutyItemApprovalStatus["CERTIFIED"] = "certified";
    DutyItemApprovalStatus["DECERTIFIED"] = "decertified";
})(DutyItemApprovalStatus = exports.DutyItemApprovalStatus || (exports.DutyItemApprovalStatus = {}));
var EcommercePlatformType;
(function (EcommercePlatformType) {
    EcommercePlatformType["COMMERCETOOLS"] = "commercetools";
    EcommercePlatformType["CUSTOM"] = "custom";
    EcommercePlatformType["HYBRIS"] = "hybris";
    EcommercePlatformType["MAGENTO"] = "magento";
    EcommercePlatformType["SHOPIFY"] = "shopify";
    EcommercePlatformType["SHOPIFY_MARKETS"] = "shopify_markets";
    EcommercePlatformType["SFCC"] = "sfcc";
    EcommercePlatformType["SOLIDUS"] = "solidus";
    EcommercePlatformType["WORKAREA"] = "workarea";
})(EcommercePlatformType = exports.EcommercePlatformType || (exports.EcommercePlatformType = {}));
var EconomicTitleLocation;
(function (EconomicTitleLocation) {
    EconomicTitleLocation["HIGH_SEAS"] = "high_seas";
    EconomicTitleLocation["ORIGINATION"] = "origination";
    EconomicTitleLocation["DESTINATION"] = "destination";
})(EconomicTitleLocation = exports.EconomicTitleLocation || (exports.EconomicTitleLocation = {}));
var EntityIdentifierType;
(function (EntityIdentifierType) {
    EntityIdentifierType["IOSS"] = "ioss";
    EntityIdentifierType["VOEC"] = "voec";
    EntityIdentifierType["ZAZ"] = "zaz";
})(EntityIdentifierType = exports.EntityIdentifierType || (exports.EntityIdentifierType = {}));
var Environment;
(function (Environment) {
    Environment["SANDBOX"] = "sandbox";
    Environment["PRODUCTION"] = "production";
})(Environment = exports.Environment || (exports.Environment = {}));
var EventType;
(function (EventType) {
    EventType["AUTHORIZATION_RETRY_UPSERTED"] = "authorization_retry_upserted";
    EventType["AUTHORIZATION_RETRY_DELETED"] = "authorization_retry_deleted";
    EventType["TEST_UPSERTED"] = "test_upserted";
    EventType["GENERATE_LOAD"] = "generate_load";
    EventType["ALDO_ITEM_UPSERTED"] = "aldo_item_upserted";
    EventType["ALDO_ITEM_DELETED"] = "aldo_item_deleted";
    EventType["ANSH_ITEM_UPSERTED"] = "ansh_item_upserted";
    EventType["ANSH_ITEM_DELETED"] = "ansh_item_deleted";
    EventType["TRANSACTION_UPSERTED"] = "transaction_upserted";
    EventType["ORGANIZATION_TRANSACTION_UPSERTED"] = "organization_transaction_upserted";
    EventType["ORGANIZATION_TRANSACTION_DELETED"] = "organization_transaction_deleted";
    EventType["STATEMENT_UPSERTED"] = "statement_upserted";
    EventType["STATEMENT_DELETED"] = "statement_deleted";
    EventType["CHANNEL_TRANSACTION_UPSERTED"] = "channel_transaction_upserted";
    EventType["CHANNEL_TRANSACTION_DELETED"] = "channel_transaction_deleted";
    EventType["CHANNEL_TRANSACTION_DELETED_V_2"] = "channel_transaction_deleted_v2";
    EventType["CHANNEL_STATEMENT_UPSERTED"] = "channel_statement_upserted";
    EventType["CHANNEL_STATEMENT_DELETED"] = "channel_statement_deleted";
    EventType["CHANNEL_PAYOUT_UPSERTED"] = "channel_payout_upserted";
    EventType["CHANNEL_PAYOUT_DELETED"] = "channel_payout_deleted";
    EventType["ORGANIZATION_PAYOUT_UPSERTED"] = "organization_payout_upserted";
    EventType["ORGANIZATION_PAYOUT_DELETED"] = "organization_payout_deleted";
    EventType["CHANNEL_PENDING_PAYOUT_TRANSACTION_UPSERTED"] = "channel_pending_payout_transaction_upserted";
    EventType["CHANNEL_PENDING_PAYOUT_TRANSACTION_DELETED"] = "channel_pending_payout_transaction_deleted";
    EventType["ORGANIZATION_PENDING_PAYOUT_TRANSACTION_UPSERTED"] = "organization_pending_payout_transaction_upserted";
    EventType["ORGANIZATION_PENDING_PAYOUT_TRANSACTION_DELETED"] = "organization_pending_payout_transaction_deleted";
    EventType["ATTRIBUTE_UPSERTED"] = "attribute_upserted";
    EventType["ATTRIBUTE_DELETED"] = "attribute_deleted";
    EventType["ATTRIBUTE_UPSERTED_V_2"] = "attribute_upserted_v2";
    EventType["ATTRIBUTE_DELETED_V_2"] = "attribute_deleted_v2";
    EventType["CATALOG_UPSERTED"] = "catalog_upserted";
    EventType["CATALOG_DELETED"] = "catalog_deleted";
    EventType["SUBCATALOG_UPSERTED"] = "subcatalog_upserted";
    EventType["SUBCATALOG_DELETED"] = "subcatalog_deleted";
    EventType["SUBCATALOG_ITEM_UPSERTED"] = "subcatalog_item_upserted";
    EventType["SUBCATALOG_ITEM_DELETED"] = "subcatalog_item_deleted";
    EventType["CATALOG_STATISTICS_UPSERTED"] = "catalog_statistics_upserted";
    EventType["CATALOG_STATISTICS_DELETED"] = "catalog_statistics_deleted";
    EventType["ITEM_INSERTED"] = "item_inserted";
    EventType["ITEM_UPDATED"] = "item_updated";
    EventType["ITEM_DELETED"] = "item_deleted";
    EventType["CHANNEL_SHOPIFY_ORDER_STATE_UPSERTED"] = "channel_shopify_order_state_upserted";
    EventType["CHANNEL_SHOPIFY_ORDER_STATE_DELETED"] = "channel_shopify_order_state_deleted";
    EventType["CHANNEL_UPSERTED"] = "channel_upserted";
    EventType["CHANNEL_DELETED"] = "channel_deleted";
    EventType["CHANNEL_CURRENCY_UPSERTED"] = "channel_currency_upserted";
    EventType["CHANNEL_CURRENCY_DELETED"] = "channel_currency_deleted";
    EventType["CHANNEL_ORGANIZATION_UPSERTED"] = "channel_organization_upserted";
    EventType["CHANNEL_ORGANIZATION_DELETED"] = "channel_organization_deleted";
    EventType["B_2_B_INVOICE_UPSERTED"] = "b2b_invoice_upserted";
    EventType["B_2_B_INVOICE_DELETED"] = "b2b_invoice_deleted";
    EventType["B_2_B_CREDIT_MEMO_UPSERTED"] = "b2b_credit_memo_upserted";
    EventType["B_2_B_CREDIT_MEMO_DELETED"] = "b2b_credit_memo_deleted";
    EventType["CONSUMER_INVOICE_UPSERTED"] = "consumer_invoice_upserted";
    EventType["CONSUMER_INVOICE_DELETED"] = "consumer_invoice_deleted";
    EventType["CREDIT_MEMO_UPSERTED"] = "credit_memo_upserted";
    EventType["CREDIT_MEMO_DELETED"] = "credit_memo_deleted";
    EventType["CROSSDOCK_SHIPMENT_UPSERTED"] = "crossdock_shipment_upserted";
    EventType["RATE_DELETED"] = "rate_deleted";
    EventType["RATE_UPSERTED"] = "rate_upserted";
    EventType["RATE_DELETED_V_3"] = "rate_deleted_v3";
    EventType["RATE_UPSERTED_V_3"] = "rate_upserted_v3";
    EventType["CUSTOMER_UPSERTED"] = "customer_upserted";
    EventType["CUSTOMER_DELETED"] = "customer_deleted";
    EventType["CUSTOMER_ADDRESS_BOOK_CONTACT_UPSERTED"] = "customer_address_book_contact_upserted";
    EventType["CUSTOMER_ADDRESS_BOOK_CONTACT_DELETED"] = "customer_address_book_contact_deleted";
    EventType["AVAILABLE_PROMOTIONS_UPSERTED"] = "available_promotions_upserted";
    EventType["AVAILABLE_PROMOTIONS_DELETED"] = "available_promotions_deleted";
    EventType["AVAILABLE_PROMOTIONS_UPSERTED_V_2"] = "available_promotions_upserted_v2";
    EventType["AVAILABLE_PROMOTIONS_DELETED_V_2"] = "available_promotions_deleted_v2";
    EventType["ALLOCATION_DELETED_V_2"] = "allocation_deleted_v2";
    EventType["ALLOCATION_UPSERTED_V_2"] = "allocation_upserted_v2";
    EventType["CURRENCY_FORMAT_DELETED"] = "currency_format_deleted";
    EventType["CURRENCY_FORMAT_UPSERTED"] = "currency_format_upserted";
    EventType["EXPERIENCE_DELETED"] = "experience_deleted";
    EventType["EXPERIENCE_UPSERTED"] = "experience_upserted";
    EventType["EXPERIENCE_DELETED_V_2"] = "experience_deleted_v2";
    EventType["EXPERIENCE_UPSERTED_V_2"] = "experience_upserted_v2";
    EventType["COUNTRY_STATUS_UPSERTED"] = "country_status_upserted";
    EventType["COUNTRY_STATUS_DELETED"] = "country_status_deleted";
    EventType["EXPERIENCE_PRICE_BOOK_MAPPING_DELETED"] = "experience_price_book_mapping_deleted";
    EventType["EXPERIENCE_PRICE_BOOK_MAPPING_UPSERTED"] = "experience_price_book_mapping_upserted";
    EventType["EXPERIENCE_LOGISTICS_SETTINGS_UPSERTED"] = "experience_logistics_settings_upserted";
    EventType["EXPERIENCE_LOGISTICS_SETTINGS_DELETED"] = "experience_logistics_settings_deleted";
    EventType["ITEM_MARGIN_DELETED_V_2"] = "item_margin_deleted_v2";
    EventType["ITEM_MARGIN_UPSERTED_V_2"] = "item_margin_upserted_v2";
    EventType["ITEM_SALES_MARGIN_DELETED"] = "item_sales_margin_deleted";
    EventType["ITEM_SALES_MARGIN_UPSERTED"] = "item_sales_margin_upserted";
    EventType["LABEL_FORMAT_DELETED"] = "label_format_deleted";
    EventType["LABEL_FORMAT_UPSERTED"] = "label_format_upserted";
    EventType["ORDER_DELETED"] = "order_deleted";
    EventType["ORDER_UPSERTED"] = "order_upserted";
    EventType["ORDER_DELETED_V_2"] = "order_deleted_v2";
    EventType["ORDER_UPSERTED_V_2"] = "order_upserted_v2";
    EventType["ORDER_IDENTIFIER_DELETED"] = "order_identifier_deleted";
    EventType["ORDER_IDENTIFIER_UPSERTED"] = "order_identifier_upserted";
    EventType["ORDER_IDENTIFIER_DELETED_V_2"] = "order_identifier_deleted_v2";
    EventType["ORDER_IDENTIFIER_UPSERTED_V_2"] = "order_identifier_upserted_v2";
    EventType["ORDER_IDENTIFIER_UPSERTED_V_3"] = "order_identifier_upserted_v3";
    EventType["ORDER_REPLACEMENT_UPSERTED"] = "order_replacement_upserted";
    EventType["ORDER_REPLACEMENT_DELETED"] = "order_replacement_deleted";
    EventType["PRICING_DELETED"] = "pricing_deleted";
    EventType["PRICING_UPSERTED"] = "pricing_upserted";
    EventType["ORDER_SERVICE_CHANGE_REQUEST"] = "order_service_change_request";
    EventType["FRAUD_STATUS_CHANGED"] = "fraud_status_changed";
    EventType["CENTER_UPSERTED"] = "center_upserted";
    EventType["CENTER_DELETED"] = "center_deleted";
    EventType["SHIPPING_CONFIGURATION_UPSERTED"] = "shipping_configuration_upserted";
    EventType["SHIPPING_CONFIGURATION_DELETED"] = "shipping_configuration_deleted";
    EventType["TIER_UPSERTED_V_2"] = "tier_upserted_v2";
    EventType["TIER_DELETED_V_2"] = "tier_deleted_v2";
    EventType["SHIPPING_LANE_UPSERTED"] = "shipping_lane_upserted";
    EventType["SHIPPING_LANE_DELETED"] = "shipping_lane_deleted";
    EventType["SHIPPING_CONFIGURATION_ITEM_AVAILABILITY_UPSERTED"] = "shipping_configuration_item_availability_upserted";
    EventType["SHIPPING_CONFIGURATION_ITEM_AVAILABILITY_DELETED"] = "shipping_configuration_item_availability_deleted";
    EventType["SHIPPING_CONFIGURATION_ITEM_SHIPPING_PRICING_UPSERTED"] = "shipping_configuration_item_shipping_pricing_upserted";
    EventType["SHIPPING_CONFIGURATION_ITEM_SHIPPING_PRICING_DELETED"] = "shipping_configuration_item_shipping_pricing_deleted";
    EventType["GE_ITEM_INSERTED"] = "ge_item_inserted";
    EventType["GE_ITEM_UPDATED"] = "ge_item_updated";
    EventType["GE_ITEM_DELETED"] = "ge_item_deleted";
    EventType["GE_PRODUCT_RESTRICTION_RESULT_UPSERTED"] = "ge_product_restriction_result_upserted";
    EventType["GE_PRODUCT_RESTRICTION_RESULT_DELETED"] = "ge_product_restriction_result_deleted";
    EventType["HS_6_CODE_UPSERTED"] = "hs6_code_upserted";
    EventType["HS_6_CODE_DELETED"] = "hs6_code_deleted";
    EventType["HS_10_CODE_UPSERTED"] = "hs10_code_upserted";
    EventType["HS_10_CODE_DELETED"] = "hs10_code_deleted";
    EventType["ITEM_ORIGIN_UPSERTED"] = "item_origin_upserted";
    EventType["ITEM_ORIGIN_DELETED"] = "item_origin_deleted";
    EventType["HARMONIZED_LANDED_COST_UPSERTED"] = "harmonized_landed_cost_upserted";
    EventType["FULLY_HARMONIZED_ITEM_UPSERTED"] = "fully_harmonized_item_upserted";
    EventType["IMPORT_COMPLETED_V_2"] = "import_completed_v2";
    EventType["IMPORT_FAILED_V_2"] = "import_failed_v2";
    EventType["LABEL_UPSERTED"] = "label_upserted";
    EventType["LABEL_DELETED_V_2"] = "label_deleted_v2";
    EventType["LABEL_UPSERTED_V_2"] = "label_upserted_v2";
    EventType["NOTIFICATION_UPSERTED_V_2"] = "notification_upserted_v2";
    EventType["NOTIFICATION_DELETED_V_2"] = "notification_deleted_v2";
    EventType["MANIFESTED_LABEL_UPSERTED"] = "manifested_label_upserted";
    EventType["MANIFESTED_LABEL_DELETED"] = "manifested_label_deleted";
    EventType["LABEL_PROCESSING_MODIFICATION_UPSERTED"] = "label_processing_modification_upserted";
    EventType["LABEL_PROCESSING_MODIFICATION_DELETED"] = "label_processing_modification_deleted";
    EventType["MERCHANT_APPLICATION_UPSERTED"] = "merchant_application_upserted";
    EventType["MERCHANT_APPLICATION_DELETED"] = "merchant_application_deleted";
    EventType["CHECKOUT_OPTIN_RESPONSES_UPSERTED"] = "checkout_optin_responses_upserted";
    EventType["CHECKOUT_OPTIN_RESPONSES_DELETED"] = "checkout_optin_responses_deleted";
    EventType["BROWSE_OPTIN_RESPONSES_UPSERTED"] = "browse_optin_responses_upserted";
    EventType["BROWSE_OPTIN_RESPONSES_DELETED"] = "browse_optin_responses_deleted";
    EventType["ORDER_PLACED"] = "order_placed";
    EventType["ORDER_PLACED_V_2"] = "order_placed_v2";
    EventType["READY_TO_FULFILL"] = "ready_to_fulfill";
    EventType["READY_TO_FULFILL_V_2"] = "ready_to_fulfill_v2";
    EventType["MEMBERSHIP_UPSERTED_V_2"] = "membership_upserted_v2";
    EventType["MEMBERSHIP_DELETED_V_2"] = "membership_deleted_v2";
    EventType["ORGANIZATION_UPSERTED"] = "organization_upserted";
    EventType["ORGANIZATION_DELETED"] = "organization_deleted";
    EventType["ORGANIZATION_UPSERTED_V_2"] = "organization_upserted_v2";
    EventType["ORGANIZATION_DELETED_V_2"] = "organization_deleted_v2";
    EventType["ORGANIZATION_DEFAULT_CONFIGURATIONS_UPSERTED"] = "organization_default_configurations_upserted";
    EventType["ORGANIZATION_DEFAULT_CONFIGURATIONS_DELETED"] = "organization_default_configurations_deleted";
    EventType["ECOMMERCE_PLATFORM_UPSERTED"] = "ecommerce_platform_upserted";
    EventType["ECOMMERCE_PLATFORM_DELETED"] = "ecommerce_platform_deleted";
    EventType["ORGANIZATION_ONBOARDING_STATE_UPSERTED"] = "organization_onboarding_state_upserted";
    EventType["ORGANIZATION_ONBOARDING_STATE_DELETED"] = "organization_onboarding_state_deleted";
    EventType["AUTHORIZATION_DELETED_V_2"] = "authorization_deleted_v2";
    EventType["AUTHORIZATION_STATUS_CHANGED"] = "authorization_status_changed";
    EventType["CARD_AUTHORIZATION_UPSERTED_V_2"] = "card_authorization_upserted_v2";
    EventType["CARD_AUTHORIZATION_DELETED_V_2"] = "card_authorization_deleted_v2";
    EventType["ONLINE_AUTHORIZATION_UPSERTED_V_2"] = "online_authorization_upserted_v2";
    EventType["ONLINE_AUTHORIZATION_DELETED_V_2"] = "online_authorization_deleted_v2";
    EventType["CAPTURE_UPSERTED_V_2"] = "capture_upserted_v2";
    EventType["CAPTURE_DELETED"] = "capture_deleted";
    EventType["CARD_UPSERTED_V_2"] = "card_upserted_v2";
    EventType["CARD_DELETED"] = "card_deleted";
    EventType["PAYMENT_UPSERTED"] = "payment_upserted";
    EventType["PAYMENT_DELETED"] = "payment_deleted";
    EventType["REFUND_UPSERTED_V_2"] = "refund_upserted_v2";
    EventType["REFUND_DELETED_V_2"] = "refund_deleted_v2";
    EventType["REFUND_CAPTURE_UPSERTED_V_2"] = "refund_capture_upserted_v2";
    EventType["REVERSAL_UPSERTED"] = "reversal_upserted";
    EventType["REVERSAL_DELETED"] = "reversal_deleted";
    EventType["CAPTURE_IDENTIFIER_UPSERTED"] = "capture_identifier_upserted";
    EventType["CAPTURE_IDENTIFIER_DELETED"] = "capture_identifier_deleted";
    EventType["REFUND_IDENTIFIER_UPSERTED"] = "refund_identifier_upserted";
    EventType["REFUND_IDENTIFIER_DELETED"] = "refund_identifier_deleted";
    EventType["VIRTUAL_CARD_CAPTURE_UPSERTED"] = "virtual_card_capture_upserted";
    EventType["VIRTUAL_CARD_CAPTURE_DELETED"] = "virtual_card_capture_deleted";
    EventType["VIRTUAL_CARD_REFUND_UPSERTED"] = "virtual_card_refund_upserted";
    EventType["VIRTUAL_CARD_REFUND_DELETED"] = "virtual_card_refund_deleted";
    EventType["PAYMENT_REQUEST_UPSERTED"] = "payment_request_upserted";
    EventType["PAYMENT_REQUEST_DELETED"] = "payment_request_deleted";
    EventType["PRICE_BOOK_UPSERTED"] = "price_book_upserted";
    EventType["PRICE_BOOK_DELETED"] = "price_book_deleted";
    EventType["PRICE_BOOK_ITEM_UPSERTED"] = "price_book_item_upserted";
    EventType["PRICE_BOOK_ITEM_DELETED"] = "price_book_item_deleted";
    EventType["PRODUCT_INSERTED"] = "product_inserted";
    EventType["PRODUCT_UPDATED"] = "product_updated";
    EventType["PRODUCT_DELETED"] = "product_deleted";
    EventType["ORGANIZATION_RATES_PUBLISHED"] = "organization_rates_published";
    EventType["RATECARD_LANE_UPSERTED"] = "ratecard_lane_upserted";
    EventType["RATECARD_LANE_DELETED"] = "ratecard_lane_deleted";
    EventType["RATECARD_UPSERTED"] = "ratecard_upserted";
    EventType["RATECARD_DELETED"] = "ratecard_deleted";
    EventType["PRODUCT_RESTRICTION_RESULT_UPSERTED"] = "product_restriction_result_upserted";
    EventType["PRODUCT_RESTRICTION_RESULT_DELETED"] = "product_restriction_result_deleted";
    EventType["RETURN_UPSERTED"] = "return_upserted";
    EventType["RETURN_DELETED"] = "return_deleted";
    EventType["RETURN_UPSERTED_V_2"] = "return_upserted_v2";
    EventType["RETURN_DELETED_V_2"] = "return_deleted_v2";
    EventType["SHOPIFY_LOCALIZATION_SETTING_UPSERTED"] = "shopify_localization_setting_upserted";
    EventType["SHOPIFY_LOCALIZATION_SETTING_DELETED"] = "shopify_localization_setting_deleted";
    EventType["TRACKING_LABEL_EVENT_UPSERTED"] = "tracking_label_event_upserted";
})(EventType = exports.EventType || (exports.EventType = {}));
var ExceptionType;
(function (ExceptionType) {
    ExceptionType["OPEN"] = "open";
    ExceptionType["CLOSED"] = "closed";
})(ExceptionType = exports.ExceptionType || (exports.ExceptionType = {}));
var ExclusionRuleState;
(function (ExclusionRuleState) {
    ExclusionRuleState["CURRENT"] = "current";
    ExclusionRuleState["DELETING"] = "deleting";
    ExclusionRuleState["UPDATING"] = "updating";
})(ExclusionRuleState = exports.ExclusionRuleState || (exports.ExclusionRuleState = {}));
var ExperienceCloneStatus;
(function (ExperienceCloneStatus) {
    ExperienceCloneStatus["PENDING"] = "pending";
    ExperienceCloneStatus["UPDATING"] = "updating";
    ExperienceCloneStatus["COMPLETED"] = "completed";
    ExperienceCloneStatus["FAILED"] = "failed";
})(ExperienceCloneStatus = exports.ExperienceCloneStatus || (exports.ExperienceCloneStatus = {}));
var ExperienceCountryStatus;
(function (ExperienceCountryStatus) {
    ExperienceCountryStatus["ENABLED"] = "enabled";
    ExperienceCountryStatus["DISABLED"] = "disabled";
})(ExperienceCountryStatus = exports.ExperienceCountryStatus || (exports.ExperienceCountryStatus = {}));
var ExperiencePaymentMethodTag;
(function (ExperiencePaymentMethodTag) {
    ExperiencePaymentMethodTag["DISPLAY"] = "display";
})(ExperiencePaymentMethodTag = exports.ExperiencePaymentMethodTag || (exports.ExperiencePaymentMethodTag = {}));
var ExperienceStatus;
(function (ExperienceStatus) {
    ExperienceStatus["DRAFT"] = "draft";
    ExperienceStatus["ACTIVE"] = "active";
    ExperienceStatus["ARCHIVING"] = "archiving";
    ExperienceStatus["ARCHIVED"] = "archived";
})(ExperienceStatus = exports.ExperienceStatus || (exports.ExperienceStatus = {}));
var ExportStatus;
(function (ExportStatus) {
    ExportStatus["CREATED"] = "created";
    ExportStatus["PROCESSING"] = "processing";
    ExportStatus["COMPLETED"] = "completed";
    ExportStatus["FAILED"] = "failed";
})(ExportStatus = exports.ExportStatus || (exports.ExportStatus = {}));
var ExporterOfRecord;
(function (ExporterOfRecord) {
    ExporterOfRecord["FLOW"] = "flow";
    ExporterOfRecord["ORGANIZATION"] = "organization";
})(ExporterOfRecord = exports.ExporterOfRecord || (exports.ExporterOfRecord = {}));
var FeeDeductionType;
(function (FeeDeductionType) {
    FeeDeductionType["DUTY_GUARANTEE"] = "duty_guarantee";
    FeeDeductionType["MOR"] = "mor";
    FeeDeductionType["FRAUD"] = "fraud";
    FeeDeductionType["FX"] = "fx";
    FeeDeductionType["PROCESSING"] = "processing";
    FeeDeductionType["RATE_LOCK"] = "rate_lock";
    FeeDeductionType["TRANSFER"] = "transfer";
    FeeDeductionType["NEGATIVE_BALANCE_GUARANTEE"] = "negative_balance_guarantee";
})(FeeDeductionType = exports.FeeDeductionType || (exports.FeeDeductionType = {}));
var FlowBehavior;
(function (FlowBehavior) {
    FlowBehavior["VIEW_CONSUMER_DATA"] = "view_consumer_data";
})(FlowBehavior = exports.FlowBehavior || (exports.FlowBehavior = {}));
var FlowEntity;
(function (FlowEntity) {
    FlowEntity["FLOW_USA"] = "flow-usa";
    FlowEntity["FLOW_IRL"] = "flow-irl";
    FlowEntity["FLOW_CAN"] = "flow-can";
    FlowEntity["GE_USA"] = "ge-usa";
})(FlowEntity = exports.FlowEntity || (exports.FlowEntity = {}));
var FlowRole;
(function (FlowRole) {
    FlowRole["ORGANIZATION_ADMIN"] = "organization_admin";
    FlowRole["ORGANIZATION_MERCHANT"] = "organization_merchant";
    FlowRole["ORGANIZATION_CUSTOMER_SERVICE"] = "organization_customer_service";
    FlowRole["ORGANIZATION_FULFILLMENT"] = "organization_fulfillment";
    FlowRole["ORGANIZATION_MARKETING"] = "organization_marketing";
    FlowRole["ORGANIZATION_FINANCE"] = "organization_finance";
    FlowRole["ORGANIZATION_CLASSIFICATION"] = "organization_classification";
    FlowRole["FLOW_OPERATIONS"] = "flow_operations";
    FlowRole["CHANNEL_ADMIN"] = "channel_admin";
    FlowRole["CHANNEL_ORGANIZATION_ADMIN"] = "channel_organization_admin";
})(FlowRole = exports.FlowRole || (exports.FlowRole = {}));
var FraudEmailRuleDecision;
(function (FraudEmailRuleDecision) {
    FraudEmailRuleDecision["APPROVED"] = "approved";
    FraudEmailRuleDecision["DECLINED"] = "declined";
})(FraudEmailRuleDecision = exports.FraudEmailRuleDecision || (exports.FraudEmailRuleDecision = {}));
var FraudLiability;
(function (FraudLiability) {
    FraudLiability["FLOW"] = "flow";
    FraudLiability["ORGANIZATION"] = "organization";
})(FraudLiability = exports.FraudLiability || (exports.FraudLiability = {}));
var FraudStatus;
(function (FraudStatus) {
    FraudStatus["PENDING"] = "pending";
    FraudStatus["APPROVED"] = "approved";
    FraudStatus["DECLINED"] = "declined";
    FraudStatus["REVIEW"] = "review";
})(FraudStatus = exports.FraudStatus || (exports.FraudStatus = {}));
var FtpFileSource;
(function (FtpFileSource) {
    FtpFileSource["FLOW"] = "flow";
    FtpFileSource["ORGANIZATION"] = "organization";
})(FtpFileSource = exports.FtpFileSource || (exports.FtpFileSource = {}));
var FulfillmentItemQuantityStatus;
(function (FulfillmentItemQuantityStatus) {
    FulfillmentItemQuantityStatus["NEW"] = "new";
    FulfillmentItemQuantityStatus["SHIPPED"] = "shipped";
    FulfillmentItemQuantityStatus["CANCELLED"] = "cancelled";
})(FulfillmentItemQuantityStatus = exports.FulfillmentItemQuantityStatus || (exports.FulfillmentItemQuantityStatus = {}));
var FulfillmentMethodType;
(function (FulfillmentMethodType) {
    FulfillmentMethodType["FULFILLMENT_METHOD"] = "fulfillment_method";
})(FulfillmentMethodType = exports.FulfillmentMethodType || (exports.FulfillmentMethodType = {}));
var FulfillmentMethodValue;
(function (FulfillmentMethodValue) {
    FulfillmentMethodValue["DIGITAL"] = "digital";
    FulfillmentMethodValue["PHYSICAL"] = "physical";
})(FulfillmentMethodValue = exports.FulfillmentMethodValue || (exports.FulfillmentMethodValue = {}));
var FulfillmentRouting;
(function (FulfillmentRouting) {
    FulfillmentRouting["FULFILLED_FROM_CENTER"] = "fulfilled_from_center";
    FulfillmentRouting["FULFILLMENT_SERVICE"] = "fulfillment_service";
})(FulfillmentRouting = exports.FulfillmentRouting || (exports.FulfillmentRouting = {}));
var GenericErrorCode;
(function (GenericErrorCode) {
    GenericErrorCode["GENERIC_ERROR"] = "generic_error";
    GenericErrorCode["CLIENT_ERROR"] = "client_error";
    GenericErrorCode["SERVER_ERROR"] = "server_error";
})(GenericErrorCode = exports.GenericErrorCode || (exports.GenericErrorCode = {}));
var GoodsSupply;
(function (GoodsSupply) {
    GoodsSupply["EXPORT"] = "export";
    GoodsSupply["INTRA_COMMUNITY"] = "intra_community";
    GoodsSupply["LOCAL"] = "local";
})(GoodsSupply = exports.GoodsSupply || (exports.GoodsSupply = {}));
var HolidayCalendar;
(function (HolidayCalendar) {
    HolidayCalendar["US_BANK_HOLIDAYS"] = "us_bank_holidays";
    HolidayCalendar["JEWISH_HOLIDAYS"] = "jewish_holidays";
})(HolidayCalendar = exports.HolidayCalendar || (exports.HolidayCalendar = {}));
var ImageTag;
(function (ImageTag) {
    ImageTag["THUMBNAIL"] = "thumbnail";
    ImageTag["CHECKOUT"] = "checkout";
})(ImageTag = exports.ImageTag || (exports.ImageTag = {}));
var ImportType;
(function (ImportType) {
    ImportType["CATALOG_ITEMS"] = "catalog_items";
    ImportType["CATALOG_ITEMS_EXTERNAL"] = "catalog_items_external";
    ImportType["CUSTOMS_DESCRIPTIONS"] = "customs_descriptions";
    ImportType["CUSTOMS_DESCRIPTION_TARIFFS"] = "customs_description_tariffs";
    ImportType["EXPERIENCES_WITH_SETTINGS"] = "experiences_with_settings";
    ImportType["HARMONIZATION_CODES"] = "harmonization_codes";
    ImportType["ITEM_PRICES"] = "item_prices";
    ImportType["ITEM_FORM_OVERLAYS"] = "item_form_overlays";
    ImportType["PRICE_BOOK_ITEMS"] = "price_book_items";
    ImportType["PRICE_BOOK_ITEMS_QUERY"] = "price_book_items_query";
    ImportType["RATECARD_LANES"] = "ratecard_lanes";
    ImportType["ORDER_SERVICE_CHANGES"] = "order_service_changes";
})(ImportType = exports.ImportType || (exports.ImportType = {}));
var IncludedLevyKey;
(function (IncludedLevyKey) {
    IncludedLevyKey["DUTY"] = "duty";
    IncludedLevyKey["VAT"] = "vat";
    IncludedLevyKey["VAT_AND_DUTY"] = "vat_and_duty";
    IncludedLevyKey["NONE"] = "none";
})(IncludedLevyKey = exports.IncludedLevyKey || (exports.IncludedLevyKey = {}));
var Incoterm;
(function (Incoterm) {
    Incoterm["EXW"] = "EXW";
    Incoterm["FCA"] = "FCA";
    Incoterm["CPT"] = "CPT";
    Incoterm["CIP"] = "CIP";
    Incoterm["DAT"] = "DAT";
    Incoterm["DAP"] = "DAP";
    Incoterm["DDP"] = "DDP";
    Incoterm["FAS"] = "FAS";
    Incoterm["FOB"] = "FOB";
    Incoterm["CFR"] = "CFR";
    Incoterm["CIF"] = "CIF";
    Incoterm["DAF"] = "DAF";
    Incoterm["DES"] = "DES";
    Incoterm["DEQ"] = "DEQ";
    Incoterm["DDU"] = "DDU";
})(Incoterm = exports.Incoterm || (exports.Incoterm = {}));
var IncotermConfiguration;
(function (IncotermConfiguration) {
    IncotermConfiguration["DDP"] = "DDP";
    IncotermConfiguration["DAP"] = "DAP";
    IncotermConfiguration["DDU"] = "DDU";
    IncotermConfiguration["UNSUPPORTED"] = "UNSUPPORTED";
})(IncotermConfiguration = exports.IncotermConfiguration || (exports.IncotermConfiguration = {}));
var InlineWindowViewportSize;
(function (InlineWindowViewportSize) {
    InlineWindowViewportSize["XXX_SMALL"] = "xxx_small";
    InlineWindowViewportSize["XX_SMALL"] = "xx_small";
    InlineWindowViewportSize["X_SMALL"] = "x_small";
    InlineWindowViewportSize["SMALL"] = "small";
    InlineWindowViewportSize["FULLSCREEN"] = "fullscreen";
    InlineWindowViewportSize["RESPONSIVE"] = "responsive";
})(InlineWindowViewportSize = exports.InlineWindowViewportSize || (exports.InlineWindowViewportSize = {}));
var InputSpecificationType;
(function (InputSpecificationType) {
    InputSpecificationType["TEXT"] = "text";
    InputSpecificationType["NUMBER"] = "number";
})(InputSpecificationType = exports.InputSpecificationType || (exports.InputSpecificationType = {}));
var InvitationErrorCode;
(function (InvitationErrorCode) {
    InvitationErrorCode["EXPIRED"] = "expired";
    InvitationErrorCode["INVALID_EMAIL"] = "invalid_email";
})(InvitationErrorCode = exports.InvitationErrorCode || (exports.InvitationErrorCode = {}));
var ItemAvailabilityStatus;
(function (ItemAvailabilityStatus) {
    ItemAvailabilityStatus["AVAILABLE"] = "available";
    ItemAvailabilityStatus["LOW"] = "low";
    ItemAvailabilityStatus["OUT_OF_STOCK"] = "out_of_stock";
})(ItemAvailabilityStatus = exports.ItemAvailabilityStatus || (exports.ItemAvailabilityStatus = {}));
var ItemIdentifier;
(function (ItemIdentifier) {
    ItemIdentifier["ITEM_NUMBER"] = "item_number";
    ItemIdentifier["SKU"] = "sku";
})(ItemIdentifier = exports.ItemIdentifier || (exports.ItemIdentifier = {}));
var LabelRequestMethod;
(function (LabelRequestMethod) {
    LabelRequestMethod["FLOW_WEB_SYNC"] = "flow_web_sync";
    LabelRequestMethod["CHANNEL_WEB_ASYNC"] = "channel_web_async";
    LabelRequestMethod["DIRECT_API_SYNC"] = "direct_api_sync";
    LabelRequestMethod["DIRECT_API_ASYNC"] = "direct_api_async";
    LabelRequestMethod["BRIDGE_API_SYNC"] = "bridge_api_sync";
    LabelRequestMethod["PARTNER_API_SYNC"] = "partner_api_sync";
    LabelRequestMethod["NOTIFICATION_REQUIRING_CROSSDOCK"] = "notification_requiring_crossdock";
    LabelRequestMethod["FLOW_SIMULATION_SYNC"] = "flow_simulation_sync";
    LabelRequestMethod["AUTOGENERATED"] = "autogenerated";
})(LabelRequestMethod = exports.LabelRequestMethod || (exports.LabelRequestMethod = {}));
var LabelTriggerMethod;
(function (LabelTriggerMethod) {
    LabelTriggerMethod["AUTOGENERATED"] = "autogenerated";
    LabelTriggerMethod["ON_DEMAND"] = "on_demand";
})(LabelTriggerMethod = exports.LabelTriggerMethod || (exports.LabelTriggerMethod = {}));
var LaneDirection;
(function (LaneDirection) {
    LaneDirection["OUTBOUND"] = "outbound";
    LaneDirection["RETURN"] = "return";
})(LaneDirection = exports.LaneDirection || (exports.LaneDirection = {}));
var LanePreselectPreference;
(function (LanePreselectPreference) {
    LanePreselectPreference["LOWEST_COST"] = "lowest_cost";
    LanePreselectPreference["DEFAULT_TIER"] = "default_tier";
})(LanePreselectPreference = exports.LanePreselectPreference || (exports.LanePreselectPreference = {}));
var LaneStrategy;
(function (LaneStrategy) {
    LaneStrategy["OLDEST"] = "oldest";
    LaneStrategy["FASTEST"] = "fastest";
    LaneStrategy["LOWEST_COST"] = "lowest_cost";
    LaneStrategy["HIGHEST_PRIORITY"] = "highest_priority";
})(LaneStrategy = exports.LaneStrategy || (exports.LaneStrategy = {}));
var LevyComponent;
(function (LevyComponent) {
    LevyComponent["GOODS"] = "goods";
    LevyComponent["DUTY"] = "duty";
    LevyComponent["INSURANCE"] = "insurance";
    LevyComponent["FREIGHT"] = "freight";
    LevyComponent["VAT"] = "vat";
})(LevyComponent = exports.LevyComponent || (exports.LevyComponent = {}));
var LevyStrategy;
(function (LevyStrategy) {
    LevyStrategy["MINIMUM"] = "minimum";
    LevyStrategy["AVERAGE"] = "average";
    LevyStrategy["MAXIMUM"] = "maximum";
})(LevyStrategy = exports.LevyStrategy || (exports.LevyStrategy = {}));
var LocationErrorCode;
(function (LocationErrorCode) {
    LocationErrorCode["ADDRESS_REQUIRED"] = "address_required";
    LocationErrorCode["IP_INVALID"] = "ip_invalid";
    LocationErrorCode["IP_REQUIRED"] = "ip_required";
    LocationErrorCode["TIMEZONE_UNAVAILABLE"] = "timezone_unavailable";
})(LocationErrorCode = exports.LocationErrorCode || (exports.LocationErrorCode = {}));
var LogisticsFormatPreference;
(function (LogisticsFormatPreference) {
    LogisticsFormatPreference["SHOPIFY_CONSOLE"] = "shopify_console";
    LogisticsFormatPreference["EXISTING_3_PL_INTEGRATION"] = "existing_3pl_integration";
    LogisticsFormatPreference["BYO_INTEGRATION"] = "byo_integration";
})(LogisticsFormatPreference = exports.LogisticsFormatPreference || (exports.LogisticsFormatPreference = {}));
var MarginType;
(function (MarginType) {
    MarginType["FIXED"] = "fixed";
    MarginType["PERCENT"] = "percent";
})(MarginType = exports.MarginType || (exports.MarginType = {}));
var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["IMPERIAL"] = "imperial";
    MeasurementSystem["METRIC"] = "metric";
})(MeasurementSystem = exports.MeasurementSystem || (exports.MeasurementSystem = {}));
var MerchantDisabledReason;
(function (MerchantDisabledReason) {
    MerchantDisabledReason["MERCHANT_DEACTIVATED"] = "merchant_deactivated";
    MerchantDisabledReason["MERCHANT_REJECTED"] = "merchant_rejected";
})(MerchantDisabledReason = exports.MerchantDisabledReason || (exports.MerchantDisabledReason = {}));
var MerchantGiftCardErrorCode;
(function (MerchantGiftCardErrorCode) {
    MerchantGiftCardErrorCode["INVALID"] = "invalid";
    MerchantGiftCardErrorCode["EXPIRED"] = "expired";
    MerchantGiftCardErrorCode["EMPTY"] = "empty";
    MerchantGiftCardErrorCode["INSUFFICIENT_FUNDS"] = "insufficient_funds";
    MerchantGiftCardErrorCode["UNSUPPORTED_CURRENCY"] = "unsupported_currency";
})(MerchantGiftCardErrorCode = exports.MerchantGiftCardErrorCode || (exports.MerchantGiftCardErrorCode = {}));
var MerchantOfRecord;
(function (MerchantOfRecord) {
    MerchantOfRecord["FLOW"] = "flow";
    MerchantOfRecord["ORGANIZATION"] = "organization";
})(MerchantOfRecord = exports.MerchantOfRecord || (exports.MerchantOfRecord = {}));
var MerchantRejectedReason;
(function (MerchantRejectedReason) {
    MerchantRejectedReason["MERCHANT_UBO_IS_PEP"] = "merchant_ubo_is_pep";
    MerchantRejectedReason["MERCHANT_CATALOG_IS_UNSUPPORTABLE"] = "merchant_catalog_is_unsupportable";
    MerchantRejectedReason["MERCHANT_FAILED_KYB_REVIEW"] = "merchant_failed_kyb_review";
})(MerchantRejectedReason = exports.MerchantRejectedReason || (exports.MerchantRejectedReason = {}));
var Method;
(function (Method) {
    Method["POST"] = "post";
})(Method = exports.Method || (exports.Method = {}));
var OnboardingApplicationStatus;
(function (OnboardingApplicationStatus) {
    OnboardingApplicationStatus["TO_DO"] = "to_do";
    OnboardingApplicationStatus["IN_PROGRESS"] = "in_progress";
    OnboardingApplicationStatus["ON_HOLD"] = "on_hold";
    OnboardingApplicationStatus["REJECTED"] = "rejected";
    OnboardingApplicationStatus["ACCEPTED"] = "accepted";
})(OnboardingApplicationStatus = exports.OnboardingApplicationStatus || (exports.OnboardingApplicationStatus = {}));
var OnboardingBlockedReason;
(function (OnboardingBlockedReason) {
    OnboardingBlockedReason["STREET_ADDRESS_IS_BLANK_3_PL"] = "street_address_is_blank_3pl";
    OnboardingBlockedReason["STREET_ADDRESS_IS_PO_BOX_3_PL"] = "street_address_is_po_box_3pl";
    OnboardingBlockedReason["BUSINESS_STREET_ADDRESS_IS_BLANK"] = "business_street_address_is_blank";
    OnboardingBlockedReason["BUSINESS_STREET_ADDRESS_IS_PO_BOX"] = "business_street_address_is_po_box";
    OnboardingBlockedReason["EXCEPTION_MERCHANT"] = "exception_merchant";
    OnboardingBlockedReason["APPLICATION_MISSING"] = "application_missing";
    OnboardingBlockedReason["MISSING_LOGISTICS_CONTACT_INFO"] = "missing_logistics_contact_info";
})(OnboardingBlockedReason = exports.OnboardingBlockedReason || (exports.OnboardingBlockedReason = {}));
var OnboardingTradeSector;
(function (OnboardingTradeSector) {
    OnboardingTradeSector["ACCESSORIES"] = "accessories";
    OnboardingTradeSector["ANIMALS_AND_PET_SUPPLIES"] = "animals_and_pet_supplies";
    OnboardingTradeSector["APPAREL"] = "apparel";
    OnboardingTradeSector["APPAREL_AND_ACCESSORIES"] = "apparel_and_accessories";
    OnboardingTradeSector["ARTS_AND_ENTERTAINMENT"] = "arts_and_entertainment";
    OnboardingTradeSector["BABY_AND_TODDLER"] = "baby_and_toddler";
    OnboardingTradeSector["BUSINESS_AND_INDUSTRIAL"] = "business_and_industrial";
    OnboardingTradeSector["CAMERAS_AND_OPTICS"] = "cameras_and_optics";
    OnboardingTradeSector["ELECTRONICS"] = "electronics";
    OnboardingTradeSector["FOOD_BEVERAGES_AND_TOBACCO"] = "food_beverages_and_tobacco";
    OnboardingTradeSector["FURNITURE"] = "furniture";
    OnboardingTradeSector["GIFT_CARDS"] = "gift_cards";
    OnboardingTradeSector["HARDWARE"] = "hardware";
    OnboardingTradeSector["HEALTH_AND_BEAUTY"] = "health_and_beauty";
    OnboardingTradeSector["HOME_AND_GARDEN"] = "home_and_garden";
    OnboardingTradeSector["JEWELRY"] = "jewelry";
    OnboardingTradeSector["LUGGAGE_AND_BAGS"] = "luggage_and_bags";
    OnboardingTradeSector["MATURE"] = "mature";
    OnboardingTradeSector["MEDIA"] = "media";
    OnboardingTradeSector["OFFICE_SUPPLIES"] = "office_supplies";
    OnboardingTradeSector["PAPER_AND_ART"] = "paper_and_art";
    OnboardingTradeSector["RELIGIOUS_AND_CEREMONIAL"] = "religious_and_ceremonial";
    OnboardingTradeSector["SOFTWARE"] = "software";
    OnboardingTradeSector["SPORTING_GOODS"] = "sporting_goods";
    OnboardingTradeSector["SPORTS_AND_FITNESS"] = "sports_and_fitness";
    OnboardingTradeSector["TOYS_AND_GAMES"] = "toys_and_games";
    OnboardingTradeSector["TOYS_HOBBIES_GIFTS"] = "toys_hobbies_gifts";
    OnboardingTradeSector["VEHICLES_AND_PARTS"] = "vehicles_and_parts";
    OnboardingTradeSector["OTHER"] = "other";
})(OnboardingTradeSector = exports.OnboardingTradeSector || (exports.OnboardingTradeSector = {}));
var OptinResponseType;
(function (OptinResponseType) {
    OptinResponseType["NOT_SHOWN"] = "not_shown";
    OptinResponseType["OPTED_IN"] = "opted_in";
    OptinResponseType["OPTED_OUT"] = "opted_out";
})(OptinResponseType = exports.OptinResponseType || (exports.OptinResponseType = {}));
var OrderChangeSource;
(function (OrderChangeSource) {
    OrderChangeSource["CONSUMER"] = "consumer";
    OrderChangeSource["RETAILER"] = "retailer";
    OrderChangeSource["FULFILLMENT"] = "fulfillment";
    OrderChangeSource["FLOW"] = "flow";
    OrderChangeSource["CARRIER"] = "carrier";
})(OrderChangeSource = exports.OrderChangeSource || (exports.OrderChangeSource = {}));
var OrderErrorCode;
(function (OrderErrorCode) {
    OrderErrorCode["GENERIC_ERROR"] = "generic_error";
    OrderErrorCode["ORDER_ITEM_NOT_AVAILABLE"] = "order_item_not_available";
    OrderErrorCode["ORDER_IDENTIFIER_ERROR"] = "order_identifier_error";
    OrderErrorCode["AUTHORIZATION_INVALID"] = "authorization_invalid";
    OrderErrorCode["DOMESTIC_SHIPPING_UNAVAILABLE"] = "domestic_shipping_unavailable";
    OrderErrorCode["SHIPPING_UNAVAILABLE"] = "shipping_unavailable";
    OrderErrorCode["VALUE_THRESHOLD_EXCEEDED"] = "value_threshold_exceeded";
    OrderErrorCode["INVALID_CURRENCY"] = "invalid_currency";
    OrderErrorCode["INVALID_COUNTRY"] = "invalid_country";
    OrderErrorCode["INVALID_REGION"] = "invalid_region";
    OrderErrorCode["INVALID_LANGUAGE"] = "invalid_language";
    OrderErrorCode["ITEM_OUT_OF_STOCK"] = "item_out_of_stock";
    OrderErrorCode["GIFT_CARD_NOT_ACCEPTED"] = "gift_card_not_accepted";
    OrderErrorCode["TOTAL_CHANGED"] = "total_changed";
})(OrderErrorCode = exports.OrderErrorCode || (exports.OrderErrorCode = {}));
var OrderMerchantOfRecord;
(function (OrderMerchantOfRecord) {
    OrderMerchantOfRecord["FLOW"] = "flow";
    OrderMerchantOfRecord["ORGANIZATION"] = "organization";
    OrderMerchantOfRecord["MIXED"] = "mixed";
})(OrderMerchantOfRecord = exports.OrderMerchantOfRecord || (exports.OrderMerchantOfRecord = {}));
var OrderPaymentSourceType;
(function (OrderPaymentSourceType) {
    OrderPaymentSourceType["GLOBALE"] = "globale";
    OrderPaymentSourceType["THIRD_PARTY"] = "third_party";
})(OrderPaymentSourceType = exports.OrderPaymentSourceType || (exports.OrderPaymentSourceType = {}));
var OrderPaymentType;
(function (OrderPaymentType) {
    OrderPaymentType["CARD"] = "card";
    OrderPaymentType["ONLINE"] = "online";
    OrderPaymentType["CREDIT"] = "credit";
    OrderPaymentType["EXTERNAL"] = "external";
    OrderPaymentType["SUBSIDIZED"] = "subsidized";
    OrderPaymentType["INSTALLMENT_PLAN"] = "installment_plan";
    OrderPaymentType["CASH_ON_DELIVERY"] = "cash_on_delivery";
})(OrderPaymentType = exports.OrderPaymentType || (exports.OrderPaymentType = {}));
var OrderPriceDetailComponentKey;
(function (OrderPriceDetailComponentKey) {
    OrderPriceDetailComponentKey["ADJUSTMENT"] = "adjustment";
    OrderPriceDetailComponentKey["VAT_DEMINIMIS"] = "vat_deminimis";
    OrderPriceDetailComponentKey["DUTY_DEMINIMIS"] = "duty_deminimis";
    OrderPriceDetailComponentKey["DUTIES_ITEM_PRICE"] = "duties_item_price";
    OrderPriceDetailComponentKey["DUTIES_FREIGHT"] = "duties_freight";
    OrderPriceDetailComponentKey["DUTIES_INSURANCE"] = "duties_insurance";
    OrderPriceDetailComponentKey["VAT_ITEM_PRICE"] = "vat_item_price";
    OrderPriceDetailComponentKey["VAT_FREIGHT"] = "vat_freight";
    OrderPriceDetailComponentKey["VAT_INSURANCE"] = "vat_insurance";
    OrderPriceDetailComponentKey["VAT_DUTIES_ITEM_PRICE"] = "vat_duties_item_price";
    OrderPriceDetailComponentKey["VAT_DUTIES_FREIGHT"] = "vat_duties_freight";
    OrderPriceDetailComponentKey["VAT_DUTIES_INSURANCE"] = "vat_duties_insurance";
    OrderPriceDetailComponentKey["ITEM_PRICE"] = "item_price";
    OrderPriceDetailComponentKey["ITEM_DISCOUNT"] = "item_discount";
    OrderPriceDetailComponentKey["ROUNDING"] = "rounding";
    OrderPriceDetailComponentKey["INSURANCE"] = "insurance";
    OrderPriceDetailComponentKey["SHIPPING"] = "shipping";
    OrderPriceDetailComponentKey["SHIPPING_DISCOUNT"] = "shipping_discount";
    OrderPriceDetailComponentKey["ORDER_DISCOUNT"] = "order_discount";
    OrderPriceDetailComponentKey["SUBTOTAL_PERCENT_SALES_MARGIN"] = "subtotal_percent_sales_margin";
    OrderPriceDetailComponentKey["SUBTOTAL_VAT_PERCENT_SALES_MARGIN"] = "subtotal_vat_percent_sales_margin";
    OrderPriceDetailComponentKey["SUBTOTAL_DUTY_PERCENT_SALES_MARGIN"] = "subtotal_duty_percent_sales_margin";
    OrderPriceDetailComponentKey["VAT_SUBSIDY"] = "vat_subsidy";
    OrderPriceDetailComponentKey["DUTY_SUBSIDY"] = "duty_subsidy";
    OrderPriceDetailComponentKey["REMOTE_AREA_SURCHARGE"] = "remote_area_surcharge";
    OrderPriceDetailComponentKey["FUEL_SURCHARGE"] = "fuel_surcharge";
    OrderPriceDetailComponentKey["EMERGENCY_SITUATION_SURCHARGE"] = "emergency_situation_surcharge";
    OrderPriceDetailComponentKey["PEAK_SURCHARGE"] = "peak_surcharge";
    OrderPriceDetailComponentKey["DUTIES_TAXES_PAID_SURCHARGE"] = "duties_taxes_paid_surcharge";
    OrderPriceDetailComponentKey["TIP"] = "tip";
})(OrderPriceDetailComponentKey = exports.OrderPriceDetailComponentKey || (exports.OrderPriceDetailComponentKey = {}));
var OrderPriceDetailKey;
(function (OrderPriceDetailKey) {
    OrderPriceDetailKey["ADJUSTMENT"] = "adjustment";
    OrderPriceDetailKey["SUBTOTAL"] = "subtotal";
    OrderPriceDetailKey["VAT"] = "vat";
    OrderPriceDetailKey["DUTY"] = "duty";
    OrderPriceDetailKey["SHIPPING"] = "shipping";
    OrderPriceDetailKey["INSURANCE"] = "insurance";
    OrderPriceDetailKey["DISCOUNT"] = "discount";
    OrderPriceDetailKey["SURCHARGES"] = "surcharges";
    OrderPriceDetailKey["TIP"] = "tip";
})(OrderPriceDetailKey = exports.OrderPriceDetailKey || (exports.OrderPriceDetailKey = {}));
var OrderRefundSummaryIncludes;
(function (OrderRefundSummaryIncludes) {
    OrderRefundSummaryIncludes["DUTIES"] = "duties";
    OrderRefundSummaryIncludes["VAT"] = "vat";
    OrderRefundSummaryIncludes["SHIPPING"] = "shipping";
})(OrderRefundSummaryIncludes = exports.OrderRefundSummaryIncludes || (exports.OrderRefundSummaryIncludes = {}));
var OrderRefundSummaryPartialCharged;
(function (OrderRefundSummaryPartialCharged) {
    OrderRefundSummaryPartialCharged["PER_ITEM"] = "per_item";
    OrderRefundSummaryPartialCharged["FOR_ORDER"] = "for_order";
    OrderRefundSummaryPartialCharged["BY_VALUE_PERCENTAGE"] = "by_value_percentage";
    OrderRefundSummaryPartialCharged["BY_QUANTITY_PERCENTAGE"] = "by_quantity_percentage";
})(OrderRefundSummaryPartialCharged = exports.OrderRefundSummaryPartialCharged || (exports.OrderRefundSummaryPartialCharged = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["OPEN"] = "open";
    OrderStatus["SUBMITTED"] = "submitted";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderStorage;
(function (OrderStorage) {
    OrderStorage["DO_NOT_PERSIST"] = "do_not_persist";
    OrderStorage["PERSIST"] = "persist";
})(OrderStorage = exports.OrderStorage || (exports.OrderStorage = {}));
var OrderType;
(function (OrderType) {
    OrderType["STANDARD"] = "standard";
    OrderType["REPLACEMENT"] = "replacement";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var OrganizationPaymentMethodTag;
(function (OrganizationPaymentMethodTag) {
    OrganizationPaymentMethodTag["DENY"] = "deny";
})(OrganizationPaymentMethodTag = exports.OrganizationPaymentMethodTag || (exports.OrganizationPaymentMethodTag = {}));
var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["ACTIVE"] = "active";
    OrganizationStatus["INACTIVE"] = "inactive";
    OrganizationStatus["DEACTIVATED"] = "deactivated";
    OrganizationStatus["PROVISIONED"] = "provisioned";
})(OrganizationStatus = exports.OrganizationStatus || (exports.OrganizationStatus = {}));
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["STANDALONE"] = "standalone";
    OrganizationType["CHANNEL"] = "channel";
})(OrganizationType = exports.OrganizationType || (exports.OrganizationType = {}));
var OriginLocationSource;
(function (OriginLocationSource) {
    OriginLocationSource["PUBLIC_HUB_CODE"] = "public_hub_code";
    OriginLocationSource["MERCHANT_HUB_CODE_OVERRIDE"] = "merchant_hub_code_override";
    OriginLocationSource["SHOPIFY"] = "shopify";
    OriginLocationSource["FALLBACK_LOCATION"] = "fallback_location";
})(OriginLocationSource = exports.OriginLocationSource || (exports.OriginLocationSource = {}));
var PackageDimensionsSource;
(function (PackageDimensionsSource) {
    PackageDimensionsSource["PROVIDED"] = "provided";
    PackageDimensionsSource["ITEM_DIMENSIONS_ESTIMATED"] = "item_dimensions_estimated";
    PackageDimensionsSource["DIMENSIONS_ESTIMATED"] = "dimensions_estimated";
    PackageDimensionsSource["DEFAULT_ITEM_DIMENSIONS_ESTIMATED"] = "default_item_dimensions_estimated";
})(PackageDimensionsSource = exports.PackageDimensionsSource || (exports.PackageDimensionsSource = {}));
var PaymentActionType;
(function (PaymentActionType) {
    PaymentActionType["REDIRECT"] = "redirect";
    PaymentActionType["REDIRECT_GET"] = "redirect_get";
    PaymentActionType["REDIRECT_POST"] = "redirect_post";
    PaymentActionType["SELECT_PAYMENT_OPTION"] = "select_payment_option";
    PaymentActionType["USE_SDK_KLARNA_V_1"] = "use_sdk_klarna_v1";
    PaymentActionType["USE_SDK_APPLEPAY_JS"] = "use_sdk_applepay_js";
    PaymentActionType["USE_SDK_GOOGLEPAY"] = "use_sdk_googlepay";
    PaymentActionType["USE_SDK_PAYPAL"] = "use_sdk_paypal";
    PaymentActionType["USE_SDK_STRIPE_V_3"] = "use_sdk_stripe_v3";
    PaymentActionType["USE_SDK_ADYEN_V_3"] = "use_sdk_adyen_v3";
    PaymentActionType["USE_SDK_ADYEN_V_4"] = "use_sdk_adyen_v4";
    PaymentActionType["EXECUTE_SCRIPT"] = "execute_script";
    PaymentActionType["DISPLAY_INLINE_WINDOW"] = "display_inline_window";
})(PaymentActionType = exports.PaymentActionType || (exports.PaymentActionType = {}));
var PaymentErrorCode;
(function (PaymentErrorCode) {
    PaymentErrorCode["DUPLICATE"] = "duplicate";
    PaymentErrorCode["INVALID_AMOUNT"] = "invalid_amount";
    PaymentErrorCode["INVALID_CURRENCY"] = "invalid_currency";
    PaymentErrorCode["INVALID_METHOD"] = "invalid_method";
    PaymentErrorCode["INVALID_ORDER"] = "invalid_order";
    PaymentErrorCode["INVALID_CUSTOMER"] = "invalid_customer";
    PaymentErrorCode["INVALID_DESTINATION"] = "invalid_destination";
    PaymentErrorCode["UNKNOWN"] = "unknown";
})(PaymentErrorCode = exports.PaymentErrorCode || (exports.PaymentErrorCode = {}));
var PaymentFailureCode;
(function (PaymentFailureCode) {
    PaymentFailureCode["ACTION_EXPIRED"] = "action_expired";
    PaymentFailureCode["ACTION_CANCELLED"] = "action_cancelled";
    PaymentFailureCode["ACTION_FAILED"] = "action_failed";
    PaymentFailureCode["AUTHORIZATION_DECLINED"] = "authorization_declined";
    PaymentFailureCode["NOT_SUPPORTED"] = "not_supported";
    PaymentFailureCode["FRAUDULENT"] = "fraudulent";
    PaymentFailureCode["ERROR"] = "error";
    PaymentFailureCode["PAYMENT_CHECKS_DECLINED"] = "payment_checks_declined";
})(PaymentFailureCode = exports.PaymentFailureCode || (exports.PaymentFailureCode = {}));
var PaymentMethodCapability;
(function (PaymentMethodCapability) {
    PaymentMethodCapability["CREDIT"] = "credit";
    PaymentMethodCapability["DEBIT"] = "debit";
})(PaymentMethodCapability = exports.PaymentMethodCapability || (exports.PaymentMethodCapability = {}));
var PaymentMethodDataOptionType;
(function (PaymentMethodDataOptionType) {
    PaymentMethodDataOptionType["IDEAL_ISSUER_OPTION"] = "ideal_issuer_option";
})(PaymentMethodDataOptionType = exports.PaymentMethodDataOptionType || (exports.PaymentMethodDataOptionType = {}));
var PaymentMethodRuleContentKey;
(function (PaymentMethodRuleContentKey) {
    PaymentMethodRuleContentKey["DESCRIPTION"] = "description";
})(PaymentMethodRuleContentKey = exports.PaymentMethodRuleContentKey || (exports.PaymentMethodRuleContentKey = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CARD"] = "card";
    PaymentMethodType["ONLINE"] = "online";
    PaymentMethodType["OFFLINE"] = "offline";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var PaymentRequestReviewCheckStatus;
(function (PaymentRequestReviewCheckStatus) {
    PaymentRequestReviewCheckStatus["PASSED"] = "passed";
    PaymentRequestReviewCheckStatus["FAILED"] = "failed";
})(PaymentRequestReviewCheckStatus = exports.PaymentRequestReviewCheckStatus || (exports.PaymentRequestReviewCheckStatus = {}));
var PaymentRequestReviewCheckType;
(function (PaymentRequestReviewCheckType) {
    PaymentRequestReviewCheckType["RESTRICTED_PARTY_SCREENING"] = "restricted_party_screening";
    PaymentRequestReviewCheckType["FRAUD_SUSPICIOUS_BEHAVIOR"] = "fraud_suspicious_behavior";
    PaymentRequestReviewCheckType["FRAUD_SUSPICIOUS_PAST_ACTIVITY"] = "fraud_suspicious_past_activity";
    PaymentRequestReviewCheckType["FRAUD_RISKY_VELOCITY"] = "fraud_risky_velocity";
    PaymentRequestReviewCheckType["FRAUD_PREVIOUS_CHARGEBACKS"] = "fraud_previous_chargebacks";
    PaymentRequestReviewCheckType["ORDER_RESTRICTED_GOODS"] = "order_restricted_goods";
    PaymentRequestReviewCheckType["ORDER_UNSUPPORTED_DESTINATION"] = "order_unsupported_destination";
    PaymentRequestReviewCheckType["ORDER_MISSING_INFORMATION"] = "order_missing_information";
    PaymentRequestReviewCheckType["ORDER_DOMESTIC"] = "order_domestic";
    PaymentRequestReviewCheckType["ORDER_MISMATCHED_CURRENCIES"] = "order_mismatched_currencies";
    PaymentRequestReviewCheckType["ORDER_MISSING"] = "order_missing";
})(PaymentRequestReviewCheckType = exports.PaymentRequestReviewCheckType || (exports.PaymentRequestReviewCheckType = {}));
var PaymentRequestReviewStatus;
(function (PaymentRequestReviewStatus) {
    PaymentRequestReviewStatus["PENDING"] = "pending";
    PaymentRequestReviewStatus["APPROVED"] = "approved";
    PaymentRequestReviewStatus["REJECTED"] = "rejected";
})(PaymentRequestReviewStatus = exports.PaymentRequestReviewStatus || (exports.PaymentRequestReviewStatus = {}));
var PaymentSourceConfirmationActionType;
(function (PaymentSourceConfirmationActionType) {
    PaymentSourceConfirmationActionType["CVV"] = "cvv";
    PaymentSourceConfirmationActionType["BILLING_ADDRESS"] = "billing_address";
    PaymentSourceConfirmationActionType["NUMBER"] = "number";
})(PaymentSourceConfirmationActionType = exports.PaymentSourceConfirmationActionType || (exports.PaymentSourceConfirmationActionType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["REQUIRES_PAYMENT_METHOD"] = "requires_payment_method";
    PaymentStatus["REQUIRES_ACTION"] = "requires_action";
    PaymentStatus["PROCESSING"] = "processing";
    PaymentStatus["CANCELLED"] = "cancelled";
    PaymentStatus["EXPIRED"] = "expired";
    PaymentStatus["AUTHORIZED"] = "authorized";
    PaymentStatus["REVERSED"] = "reversed";
    PaymentStatus["CAPTURED"] = "captured";
    PaymentStatus["REFUNDED"] = "refunded";
    PaymentStatus["IN_DISPUTE"] = "in_dispute";
    PaymentStatus["CHARGED_BACK"] = "charged_back";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["CARD"] = "card";
    PaymentType["KLARNA"] = "klarna";
    PaymentType["GOOGLEPAY"] = "googlepay";
    PaymentType["PAYPAL"] = "paypal";
    PaymentType["APPLEPAY"] = "applepay";
    PaymentType["IDEAL"] = "ideal";
    PaymentType["SOFORT"] = "sofort";
    PaymentType["AFTERPAY"] = "afterpay";
    PaymentType["BANCONTACT"] = "bancontact";
    PaymentType["TWINT"] = "twint";
    PaymentType["PRZELEWY_24"] = "przelewy24";
    PaymentType["MOBILEPAY"] = "mobilepay";
    PaymentType["GRABPAY"] = "grabpay";
    PaymentType["VIPPS"] = "vipps";
    PaymentType["KCP_CREDITCARD"] = "kcp_creditcard";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PayoutAttachmentType;
(function (PayoutAttachmentType) {
    PayoutAttachmentType["TRANSACTIONS"] = "transactions";
})(PayoutAttachmentType = exports.PayoutAttachmentType || (exports.PayoutAttachmentType = {}));
var PayoutStatusFailureCode;
(function (PayoutStatusFailureCode) {
    PayoutStatusFailureCode["INVALID_ACCOUNT_NUMBER"] = "invalid_account_number";
    PayoutStatusFailureCode["ACCOUNT_CLOSED"] = "account_closed";
    PayoutStatusFailureCode["COULD_NOT_PROCESS"] = "could_not_process";
})(PayoutStatusFailureCode = exports.PayoutStatusFailureCode || (exports.PayoutStatusFailureCode = {}));
var PendingPayoutTransactionReasonCode;
(function (PendingPayoutTransactionReasonCode) {
    PendingPayoutTransactionReasonCode["WAITING_FOR_FULL_REFUND"] = "waiting_for_full_refund";
    PendingPayoutTransactionReasonCode["WAITING_FOR_FULFILLMENT"] = "waiting_for_fulfillment";
    PendingPayoutTransactionReasonCode["WAITING_FOR_IN_TRANSIT"] = "waiting_for_in_transit";
    PendingPayoutTransactionReasonCode["WAITING_FOR_NEXT_PAYOUT_DATE"] = "waiting_for_next_payout_date";
    PendingPayoutTransactionReasonCode["WAITING_FOR_TRACKING_INFO"] = "waiting_for_tracking_info";
    PendingPayoutTransactionReasonCode["WAITING_FOR_POSITIVE_ACCOUNT_BALANCE"] = "waiting_for_positive_account_balance";
    PendingPayoutTransactionReasonCode["UNFULFILLED_AMOUNT_GREATER_THAN_NEGATIVE_BALANCE"] = "unfulfilled_amount_greater_than_negative_balance";
    PendingPayoutTransactionReasonCode["ACCOUNT_PAYMENT_HOLD"] = "account_payment_hold";
})(PendingPayoutTransactionReasonCode = exports.PendingPayoutTransactionReasonCode || (exports.PendingPayoutTransactionReasonCode = {}));
var PermittedHttpMethod;
(function (PermittedHttpMethod) {
    PermittedHttpMethod["GET"] = "GET";
    PermittedHttpMethod["POST"] = "POST";
    PermittedHttpMethod["PUT"] = "PUT";
    PermittedHttpMethod["DELETE"] = "DELETE";
    PermittedHttpMethod["PATCH"] = "PATCH";
})(PermittedHttpMethod = exports.PermittedHttpMethod || (exports.PermittedHttpMethod = {}));
var PhysicalDeliverySpecialSerivce;
(function (PhysicalDeliverySpecialSerivce) {
    PhysicalDeliverySpecialSerivce["COLD_STORAGE"] = "cold_storage";
    PhysicalDeliverySpecialSerivce["HAZARDOUS"] = "hazardous";
    PhysicalDeliverySpecialSerivce["PERISHABLE"] = "perishable";
})(PhysicalDeliverySpecialSerivce = exports.PhysicalDeliverySpecialSerivce || (exports.PhysicalDeliverySpecialSerivce = {}));
var PostalType;
(function (PostalType) {
    PostalType["EIRCODE"] = "eircode";
    PostalType["PIN"] = "pin";
    PostalType["POSTAL"] = "postal";
    PostalType["ZIP"] = "zip";
})(PostalType = exports.PostalType || (exports.PostalType = {}));
var PreferredServiceSelectionStrategy;
(function (PreferredServiceSelectionStrategy) {
    PreferredServiceSelectionStrategy["CALCULATED_RATE"] = "calculated_rate";
    PreferredServiceSelectionStrategy["FLAT_RATE"] = "flat_rate";
    PreferredServiceSelectionStrategy["CUSTOM_RATE"] = "custom_rate";
})(PreferredServiceSelectionStrategy = exports.PreferredServiceSelectionStrategy || (exports.PreferredServiceSelectionStrategy = {}));
var PriceAccuracy;
(function (PriceAccuracy) {
    PriceAccuracy["CALCULATED"] = "calculated";
    PriceAccuracy["ESTIMATED_FROM_PARTIAL_DESTINATION"] = "estimated_from_partial_destination";
})(PriceAccuracy = exports.PriceAccuracy || (exports.PriceAccuracy = {}));
var PriceBookStatus;
(function (PriceBookStatus) {
    PriceBookStatus["DRAFT"] = "draft";
    PriceBookStatus["PUBLISHED"] = "published";
    PriceBookStatus["ARCHIVED"] = "archived";
})(PriceBookStatus = exports.PriceBookStatus || (exports.PriceBookStatus = {}));
var PriceDetailComponentKey;
(function (PriceDetailComponentKey) {
    PriceDetailComponentKey["BASE_PRICE"] = "base_price";
    PriceDetailComponentKey["DISCOUNT"] = "discount";
    PriceDetailComponentKey["CURRENCY_MARGIN"] = "currency_margin";
    PriceDetailComponentKey["PERCENT_ITEM_MARGIN"] = "percent_item_margin";
    PriceDetailComponentKey["FIXED_ITEM_MARGIN"] = "fixed_item_margin";
    PriceDetailComponentKey["DUTIES_ITEM_PRICE"] = "duties_item_price";
    PriceDetailComponentKey["DUTIES_ADDED_MARGIN"] = "duties_added_margin";
    PriceDetailComponentKey["DUTIES_ROUNDING"] = "duties_rounding";
    PriceDetailComponentKey["DUTIES_DEMINIMIS"] = "duties_deminimis";
    PriceDetailComponentKey["VAT_ITEM_PRICE"] = "vat_item_price";
    PriceDetailComponentKey["VAT_ADDED_MARGIN"] = "vat_added_margin";
    PriceDetailComponentKey["VAT_ROUNDING"] = "vat_rounding";
    PriceDetailComponentKey["VAT_DUTIES_ITEM_PRICE"] = "vat_duties_item_price";
    PriceDetailComponentKey["VAT_DUTIES_ADDED_MARGIN"] = "vat_duties_added_margin";
    PriceDetailComponentKey["VAT_DUTIES_ROUNDING"] = "vat_duties_rounding";
    PriceDetailComponentKey["VAT_DEMINIMIS"] = "vat_deminimis";
    PriceDetailComponentKey["ITEM_PRICE_PERCENT_SALES_MARGIN"] = "item_price_percent_sales_margin";
    PriceDetailComponentKey["MARGINS_PERCENT_SALES_MARGIN"] = "margins_percent_sales_margin";
    PriceDetailComponentKey["ROUNDING_PERCENT_SALES_MARGIN"] = "rounding_percent_sales_margin";
    PriceDetailComponentKey["VAT_PERCENT_SALES_MARGIN"] = "vat_percent_sales_margin";
    PriceDetailComponentKey["VAT_DUTY_PERCENT_SALES_MARGIN"] = "vat_duty_percent_sales_margin";
    PriceDetailComponentKey["DUTY_PERCENT_SALES_MARGIN"] = "duty_percent_sales_margin";
})(PriceDetailComponentKey = exports.PriceDetailComponentKey || (exports.PriceDetailComponentKey = {}));
var PriceDetailKey;
(function (PriceDetailKey) {
    PriceDetailKey["ITEM_PRICE"] = "item_price";
    PriceDetailKey["MARGINS"] = "margins";
    PriceDetailKey["VAT"] = "vat";
    PriceDetailKey["DUTY"] = "duty";
    PriceDetailKey["ROUNDING"] = "rounding";
    PriceDetailKey["ADJUSTMENT"] = "adjustment";
})(PriceDetailKey = exports.PriceDetailKey || (exports.PriceDetailKey = {}));
var PriceFacetBoundary;
(function (PriceFacetBoundary) {
    PriceFacetBoundary["MIN"] = "min";
    PriceFacetBoundary["MAX"] = "max";
})(PriceFacetBoundary = exports.PriceFacetBoundary || (exports.PriceFacetBoundary = {}));
var PricingLevySetting;
(function (PricingLevySetting) {
    PricingLevySetting["INCLUDED"] = "included";
    PricingLevySetting["DISPLAYED"] = "displayed";
    PricingLevySetting["IGNORED"] = "ignored";
})(PricingLevySetting = exports.PricingLevySetting || (exports.PricingLevySetting = {}));
var ProductRestrictionRule;
(function (ProductRestrictionRule) {
    ProductRestrictionRule["ADULT_PRODUCT"] = "Adult Products";
    ProductRestrictionRule["ALCOHOL"] = "Alcohol";
    ProductRestrictionRule["ANTI_MONEY_LAUNDERING"] = "Anti Money Laundering";
    ProductRestrictionRule["COLLAGEN"] = "Collagen";
    ProductRestrictionRule["CONSUMER_SAFETY"] = "Consumer Safety";
    ProductRestrictionRule["COSMETICS"] = "Cosmetics";
    ProductRestrictionRule["DG_BATTERIES"] = "DG - Batteries";
    ProductRestrictionRule["DG_HAZMAT"] = "DG - Hazmat";
    ProductRestrictionRule["DRUGS"] = "Drugs";
    ProductRestrictionRule["DUAL_USE"] = "Dual Use";
    ProductRestrictionRule["FINE_ART"] = "Fine Art";
    ProductRestrictionRule["FISH_WILDLIFE_CITES"] = "Fish & Wildlife - CITES";
    ProductRestrictionRule["FISH_WILDLIFE_PLANT"] = "Fish & Wildlife - Plant";
    ProductRestrictionRule["FISH_WILDLIFE_USFWS"] = "Fish & Wildlife - USFWS";
    ProductRestrictionRule["FOOD"] = "Food";
    ProductRestrictionRule["GAMBLING"] = "Gambling";
    ProductRestrictionRule["HEALTH"] = "Health";
    ProductRestrictionRule["HUMAN_HAIR"] = "Human hair";
    ProductRestrictionRule["INSUFFICIENT_DETAILS"] = "Insufficient Details";
    ProductRestrictionRule["INTANGIBLE"] = "Intangible";
    ProductRestrictionRule["JEWELRY"] = "Jewelry";
    ProductRestrictionRule["JEWELRY_WATCHES_OVER_LIMIT"] = "Jewelry & Watches Over 5000";
    ProductRestrictionRule["KNIVES"] = "Knives";
    ProductRestrictionRule["LIQUIDS"] = "Liquids";
    ProductRestrictionRule["OVERSIZED"] = "Oversized";
    ProductRestrictionRule["RESTRICT_BY_DEFAULT"] = "Restrict by Default";
    ProductRestrictionRule["SUPPLEMENTS"] = "Supplements";
    ProductRestrictionRule["TATTOO_INK_AND_PMU"] = "Tattoo Ink And PMU";
    ProductRestrictionRule["WEAPON"] = "Weapon";
    ProductRestrictionRule["WOOD"] = "Wood";
})(ProductRestrictionRule = exports.ProductRestrictionRule || (exports.ProductRestrictionRule = {}));
var PromotionTriggerType;
(function (PromotionTriggerType) {
    PromotionTriggerType["AUTOMATIC"] = "automatic";
    PromotionTriggerType["ORDER_SUBTOTAL"] = "order_subtotal";
})(PromotionTriggerType = exports.PromotionTriggerType || (exports.PromotionTriggerType = {}));
var ProvinceType;
(function (ProvinceType) {
    ProvinceType["AREA"] = "area";
    ProvinceType["CITY"] = "city";
    ProvinceType["COUNTY"] = "county";
    ProvinceType["DEPARTMENT"] = "department";
    ProvinceType["DEPENDENCY"] = "dependency";
    ProvinceType["DISTRICT"] = "district";
    ProvinceType["DO_SI"] = "do_si";
    ProvinceType["EMIRATE"] = "emirate";
    ProvinceType["ENTITY"] = "entity";
    ProvinceType["ISLAND"] = "island";
    ProvinceType["MUNICIPALITY"] = "municipality";
    ProvinceType["OBLAST"] = "oblast";
    ProvinceType["OUTLYING_AREA"] = "outlying_area";
    ProvinceType["PARISH"] = "parish";
    ProvinceType["PREFECTURE"] = "prefecture";
    ProvinceType["PROVINCE"] = "province";
    ProvinceType["STATE"] = "state";
    ProvinceType["TERRITORY"] = "territory";
    ProvinceType["OTHER"] = "other";
})(ProvinceType = exports.ProvinceType || (exports.ProvinceType = {}));
var QuoteErrorCode;
(function (QuoteErrorCode) {
    QuoteErrorCode["GENERIC_ERROR"] = "generic_error";
    QuoteErrorCode["ITEMS_NOT_AVAILABLE"] = "items_not_available";
    QuoteErrorCode["SHIPPING_UNAVAILABLE"] = "shipping_unavailable";
})(QuoteErrorCode = exports.QuoteErrorCode || (exports.QuoteErrorCode = {}));
var RatecardOwner;
(function (RatecardOwner) {
    RatecardOwner["FLOW"] = "flow";
    RatecardOwner["ORGANIZATION"] = "organization";
})(RatecardOwner = exports.RatecardOwner || (exports.RatecardOwner = {}));
var RefundDeclineCode;
(function (RefundDeclineCode) {
    RefundDeclineCode["EXPIRED"] = "expired";
    RefundDeclineCode["INSUFFICIENT_FUNDS"] = "insufficient_funds";
    RefundDeclineCode["UNKNOWN"] = "unknown";
})(RefundDeclineCode = exports.RefundDeclineCode || (exports.RefundDeclineCode = {}));
var RefundFailureCategory;
(function (RefundFailureCategory) {
    RefundFailureCategory["AMOUNT_TOO_HIGH"] = "amount_too_high";
    RefundFailureCategory["AMOUNT_TOO_LOW"] = "amount_too_low";
    RefundFailureCategory["NOT_ENOUGH_BALANCE"] = "not_enough_balance";
    RefundFailureCategory["INSUFFICIENT_FUNDS"] = "insufficient_funds";
    RefundFailureCategory["REFUND_PERIOD_EXPIRED"] = "refund_period_expired";
    RefundFailureCategory["DISPUTE"] = "dispute";
    RefundFailureCategory["NOT_CAPTURED"] = "not_captured";
    RefundFailureCategory["UNSUPPORTED_PAYMENT_METHOD"] = "unsupported_payment_method";
    RefundFailureCategory["UNSUPPORTED_PARTIAL_REFUND"] = "unsupported_partial_refund";
    RefundFailureCategory["INVALID_CURRENCY"] = "invalid_currency";
    RefundFailureCategory["CARD_NO_LONGER_VALID"] = "card_no_longer_valid";
    RefundFailureCategory["GENERAL"] = "general";
})(RefundFailureCategory = exports.RefundFailureCategory || (exports.RefundFailureCategory = {}));
var RefundStatus;
(function (RefundStatus) {
    RefundStatus["PENDING"] = "pending";
    RefundStatus["SUCCEEDED"] = "succeeded";
    RefundStatus["FAILED"] = "failed";
    RefundStatus["CANCELED"] = "canceled";
})(RefundStatus = exports.RefundStatus || (exports.RefundStatus = {}));
var RegionType;
(function (RegionType) {
    RegionType["STATE"] = "state";
    RegionType["PROVINCE"] = "province";
    RegionType["JURISDICTION"] = "jurisdiction";
})(RegionType = exports.RegionType || (exports.RegionType = {}));
var RestrictedReviewStatus;
(function (RestrictedReviewStatus) {
    RestrictedReviewStatus["IN_REVIEW"] = "in_review";
    RestrictedReviewStatus["REVIEWED"] = "reviewed";
})(RestrictedReviewStatus = exports.RestrictedReviewStatus || (exports.RestrictedReviewStatus = {}));
var ReturnItemStatus;
(function (ReturnItemStatus) {
    ReturnItemStatus["RETURNABLE"] = "returnable";
    ReturnItemStatus["NON_RETURNABLE"] = "non-returnable";
})(ReturnItemStatus = exports.ReturnItemStatus || (exports.ReturnItemStatus = {}));
var ReturnPolicyState;
(function (ReturnPolicyState) {
    ReturnPolicyState["CURRENT"] = "current";
    ReturnPolicyState["DELETING"] = "deleting";
    ReturnPolicyState["UPDATING"] = "updating";
})(ReturnPolicyState = exports.ReturnPolicyState || (exports.ReturnPolicyState = {}));
var ReturnStatus;
(function (ReturnStatus) {
    ReturnStatus["OPEN"] = "open";
    ReturnStatus["REFUNDED"] = "refunded";
})(ReturnStatus = exports.ReturnStatus || (exports.ReturnStatus = {}));
var ReturnTrackingStatus;
(function (ReturnTrackingStatus) {
    ReturnTrackingStatus["AWAITING_CUSTOMS_CLEARANCE"] = "awaiting_customs_clearance";
    ReturnTrackingStatus["CANCEL_REQUESTED"] = "cancel_requested";
    ReturnTrackingStatus["CANCELED"] = "canceled";
    ReturnTrackingStatus["COLLECTION_ATTEMPT_FAILED"] = "collection_attempt_failed";
    ReturnTrackingStatus["CUSTOMS_CLEARANCE_COMPLETED"] = "customs_clearance_completed";
    ReturnTrackingStatus["DELIVERED_TO_RETAILER"] = "delivered_to_retailer";
    ReturnTrackingStatus["IN_TRANSIT_TO_LOCAL_HUB"] = "in_transit_to_local_hub";
    ReturnTrackingStatus["IN_TRANSIT_TO_RETAILER"] = "in_transit_to_retailer";
    ReturnTrackingStatus["PARCEL_ADDED_TO_PALLET"] = "parcel_added_to_pallet";
    ReturnTrackingStatus["PARCEL_DELAYED"] = "parcel_delayed";
    ReturnTrackingStatus["PARCEL_EXTRACTED_FROM_PALLET"] = "parcel_extracted_from_pallet";
    ReturnTrackingStatus["PARCEL_LOST"] = "parcel_lost";
    ReturnTrackingStatus["PARCEL_PROCESSED_BY_RETAILER"] = "parcel_processed_by_retailer";
    ReturnTrackingStatus["PARCEL_UNDER_INVESTIGATION"] = "parcel_under_investigation";
    ReturnTrackingStatus["PROCESSED_BY_LOCAL_HUB"] = "processed_by_local_hub";
    ReturnTrackingStatus["RECEIVED_AT_LOCAL_HUB"] = "received_at_local_hub";
    ReturnTrackingStatus["RECEIVED_BY_THE_CARRIER"] = "received_by_the_carrier";
    ReturnTrackingStatus["RETURN_REGISTERED_ONLINE"] = "return_registered_online";
})(ReturnTrackingStatus = exports.ReturnTrackingStatus || (exports.ReturnTrackingStatus = {}));
var ReversalErrorCode;
(function (ReversalErrorCode) {
    ReversalErrorCode["AMOUNT_EXCEEDS_BALANCE"] = "amount_exceeds_balance";
    ReversalErrorCode["AUTHORIZATION_DECLINED"] = "authorization_declined";
    ReversalErrorCode["AUTHORIZATION_EXPIRED"] = "authorization_expired";
    ReversalErrorCode["INVALID_AUTHORIZATION"] = "invalid_authorization";
    ReversalErrorCode["INVALID_KEY"] = "invalid_key";
    ReversalErrorCode["INVALID_AMOUNT"] = "invalid_amount";
    ReversalErrorCode["INVALID_CURRENCY"] = "invalid_currency";
    ReversalErrorCode["NO_REMAINING_BALANCE"] = "no_remaining_balance";
    ReversalErrorCode["PARTIAL_REVERSAL_NOT_SUPPORTED"] = "partial_reversal_not_supported";
    ReversalErrorCode["UNKNOWN"] = "unknown";
})(ReversalErrorCode = exports.ReversalErrorCode || (exports.ReversalErrorCode = {}));
var ReversalStatus;
(function (ReversalStatus) {
    ReversalStatus["PENDING"] = "pending";
    ReversalStatus["PROCESSED"] = "processed";
    ReversalStatus["FAILED"] = "failed";
})(ReversalStatus = exports.ReversalStatus || (exports.ReversalStatus = {}));
var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["HIGH_RISK_IN_REVIEW"] = "high_risk_in_review";
    ReviewStatus["LOW_RISK_IN_REVIEW"] = "low_risk_in_review";
    ReviewStatus["REVIEWED"] = "reviewed";
})(ReviewStatus = exports.ReviewStatus || (exports.ReviewStatus = {}));
var Role;
(function (Role) {
    Role["ADMIN"] = "admin";
    Role["MEMBER"] = "member";
})(Role = exports.Role || (exports.Role = {}));
var RoundingMethod;
(function (RoundingMethod) {
    RoundingMethod["UP"] = "up";
    RoundingMethod["DOWN"] = "down";
    RoundingMethod["NEAREST"] = "nearest";
})(RoundingMethod = exports.RoundingMethod || (exports.RoundingMethod = {}));
var RoundingType;
(function (RoundingType) {
    RoundingType["PATTERN"] = "pattern";
    RoundingType["MULTIPLE"] = "multiple";
})(RoundingType = exports.RoundingType || (exports.RoundingType = {}));
var ScheduleExceptionStatus;
(function (ScheduleExceptionStatus) {
    ScheduleExceptionStatus["OPEN"] = "Open";
    ScheduleExceptionStatus["CLOSED"] = "Closed";
})(ScheduleExceptionStatus = exports.ScheduleExceptionStatus || (exports.ScheduleExceptionStatus = {}));
var ShipmentIntegrationType;
(function (ShipmentIntegrationType) {
    ShipmentIntegrationType["DIRECT"] = "direct";
    ShipmentIntegrationType["INFORMATION"] = "information";
    ShipmentIntegrationType["PREADVICE"] = "preadvice";
})(ShipmentIntegrationType = exports.ShipmentIntegrationType || (exports.ShipmentIntegrationType = {}));
var ShipmentRecipient;
(function (ShipmentRecipient) {
    ShipmentRecipient["CUSTOMER"] = "customer";
    ShipmentRecipient["RETURN"] = "return";
    ShipmentRecipient["CROSSDOCK"] = "crossdock";
})(ShipmentRecipient = exports.ShipmentRecipient || (exports.ShipmentRecipient = {}));
var ShippingConfigurationType;
(function (ShippingConfigurationType) {
    ShippingConfigurationType["DEFAULT"] = "default";
    ShippingConfigurationType["VARIANT"] = "variant";
})(ShippingConfigurationType = exports.ShippingConfigurationType || (exports.ShippingConfigurationType = {}));
var ShippingLabelErrorCode;
(function (ShippingLabelErrorCode) {
    ShippingLabelErrorCode["GENERIC_ERROR"] = "generic_error";
    ShippingLabelErrorCode["CANCELLED_ORDER"] = "cancelled_order";
    ShippingLabelErrorCode["CARRIER_OUTAGE"] = "carrier_outage";
    ShippingLabelErrorCode["CATALOG_ISSUE"] = "catalog_issue";
    ShippingLabelErrorCode["INVALID_DESTINATION"] = "invalid_destination";
    ShippingLabelErrorCode["INVALID_ORIGIN"] = "invalid_origin";
    ShippingLabelErrorCode["INVALID_SHIPPING_PARAMETERS"] = "invalid_shipping_parameters";
    ShippingLabelErrorCode["MERCHANT_ERROR"] = "merchant_error";
    ShippingLabelErrorCode["ORDER_NOT_FOUND"] = "order_not_found";
    ShippingLabelErrorCode["ORDER_PROCESSING"] = "order_processing";
    ShippingLabelErrorCode["RESTRICTED_ITEM"] = "restricted_item";
    ShippingLabelErrorCode["UNSUPPORTED_LANE"] = "unsupported_lane";
})(ShippingLabelErrorCode = exports.ShippingLabelErrorCode || (exports.ShippingLabelErrorCode = {}));
var ShopifyGrant;
(function (ShopifyGrant) {
    ShopifyGrant["CUSTOMER"] = "customer";
    ShopifyGrant["DISCOUNT"] = "discount";
    ShopifyGrant["GIFT_CARD"] = "gift_card";
    ShopifyGrant["METAFIELD"] = "metafield";
    ShopifyGrant["ORDER"] = "order";
})(ShopifyGrant = exports.ShopifyGrant || (exports.ShopifyGrant = {}));
var ShopifyLocalizationMethod;
(function (ShopifyLocalizationMethod) {
    ShopifyLocalizationMethod["API"] = "api";
    ShopifyLocalizationMethod["SSR"] = "ssr";
})(ShopifyLocalizationMethod = exports.ShopifyLocalizationMethod || (exports.ShopifyLocalizationMethod = {}));
var ShopifySyncCheck;
(function (ShopifySyncCheck) {
    ShopifySyncCheck["LOCALIZED_VARIANTS"] = "localized_variants";
    ShopifySyncCheck["FLOW_VARIANT_METAFIELDS"] = "flow_variant_metafields";
})(ShopifySyncCheck = exports.ShopifySyncCheck || (exports.ShopifySyncCheck = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASCENDING"] = "ascending";
    SortDirection["DESCENDING"] = "descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var StatementAttachmentType;
(function (StatementAttachmentType) {
    StatementAttachmentType["CSV"] = "csv";
})(StatementAttachmentType = exports.StatementAttachmentType || (exports.StatementAttachmentType = {}));
var StoredMethodUsageStep;
(function (StoredMethodUsageStep) {
    StoredMethodUsageStep["INITIAL"] = "initial";
    StoredMethodUsageStep["SUBSEQUENT"] = "subsequent";
})(StoredMethodUsageStep = exports.StoredMethodUsageStep || (exports.StoredMethodUsageStep = {}));
var Strategy;
(function (Strategy) {
    Strategy["RANGE"] = "range";
    Strategy["FROM"] = "from";
    Strategy["TO"] = "to";
})(Strategy = exports.Strategy || (exports.Strategy = {}));
var SubcatalogItemStatus;
(function (SubcatalogItemStatus) {
    SubcatalogItemStatus["EXCLUDED"] = "excluded";
    SubcatalogItemStatus["INCLUDED"] = "included";
    SubcatalogItemStatus["RESTRICTED"] = "restricted";
})(SubcatalogItemStatus = exports.SubcatalogItemStatus || (exports.SubcatalogItemStatus = {}));
var SubstatusCode;
(function (SubstatusCode) {
    SubstatusCode["DELIVERED_001"] = "Delivered_001";
    SubstatusCode["DELIVERED_002"] = "Delivered_002";
    SubstatusCode["DELIVERED_003"] = "Delivered_003";
    SubstatusCode["DELIVERED_004"] = "Delivered_004";
    SubstatusCode["AVAILABLE_FOR_PICKUP_001"] = "AvailableForPickup_001";
    SubstatusCode["EXCEPTION_001"] = "Exception_001";
    SubstatusCode["EXCEPTION_002"] = "Exception_002";
    SubstatusCode["EXCEPTION_003"] = "Exception_003";
    SubstatusCode["EXCEPTION_004"] = "Exception_004";
    SubstatusCode["EXCEPTION_005"] = "Exception_005";
    SubstatusCode["EXCEPTION_006"] = "Exception_006";
    SubstatusCode["EXCEPTION_007"] = "Exception_007";
    SubstatusCode["EXCEPTION_008"] = "Exception_008";
    SubstatusCode["EXCEPTION_009"] = "Exception_009";
    SubstatusCode["EXCEPTION_010"] = "Exception_010";
    SubstatusCode["EXCEPTION_011"] = "Exception_011";
    SubstatusCode["EXCEPTION_012"] = "Exception_012";
    SubstatusCode["EXCEPTION_013"] = "Exception_013";
    SubstatusCode["ATTEMPT_FAIL_001"] = "AttemptFail_001";
    SubstatusCode["ATTEMPT_FAIL_002"] = "AttemptFail_002";
    SubstatusCode["ATTEMPT_FAIL_003"] = "AttemptFail_003";
    SubstatusCode["IN_TRANSIT_001"] = "InTransit_001";
    SubstatusCode["IN_TRANSIT_002"] = "InTransit_002";
    SubstatusCode["IN_TRANSIT_003"] = "InTransit_003";
    SubstatusCode["IN_TRANSIT_004"] = "InTransit_004";
    SubstatusCode["IN_TRANSIT_005"] = "InTransit_005";
    SubstatusCode["IN_TRANSIT_006"] = "InTransit_006";
    SubstatusCode["IN_TRANSIT_007"] = "InTransit_007";
    SubstatusCode["IN_TRANSIT_008"] = "InTransit_008";
    SubstatusCode["IN_TRANSIT_009"] = "InTransit_009";
    SubstatusCode["INFO_RECEIVED_001"] = "InfoReceived_001";
    SubstatusCode["OUT_FOR_DELIVERY_001"] = "OutForDelivery_001";
    SubstatusCode["OUT_FOR_DELIVERY_003"] = "OutForDelivery_003";
    SubstatusCode["OUT_FOR_DELIVERY_004"] = "OutForDelivery_004";
    SubstatusCode["PENDING_001"] = "Pending_001";
    SubstatusCode["PENDING_002"] = "Pending_002";
    SubstatusCode["PENDING_003"] = "Pending_003";
    SubstatusCode["PENDING_004"] = "Pending_004";
    SubstatusCode["PENDING_005"] = "Pending_005";
    SubstatusCode["PENDING_006"] = "Pending_006";
    SubstatusCode["EXPIRED_001"] = "Expired_001";
})(SubstatusCode = exports.SubstatusCode || (exports.SubstatusCode = {}));
var SurchargeResponsibleParty;
(function (SurchargeResponsibleParty) {
    SurchargeResponsibleParty["ORGANIZATION"] = "organization";
    SurchargeResponsibleParty["CUSTOMER"] = "customer";
})(SurchargeResponsibleParty = exports.SurchargeResponsibleParty || (exports.SurchargeResponsibleParty = {}));
var TaxApplicability;
(function (TaxApplicability) {
    TaxApplicability["NONE"] = "none";
    TaxApplicability["ALL"] = "all";
})(TaxApplicability = exports.TaxApplicability || (exports.TaxApplicability = {}));
var TaxReportType;
(function (TaxReportType) {
    TaxReportType["CONSUMER"] = "consumer";
    TaxReportType["B_2_B"] = "b2b";
})(TaxReportType = exports.TaxReportType || (exports.TaxReportType = {}));
var TaxVerificationResult;
(function (TaxVerificationResult) {
    TaxVerificationResult["VALID"] = "valid";
    TaxVerificationResult["INVALID"] = "invalid";
    TaxVerificationResult["UNABLE_TO_VALIDATE"] = "unable_to_validate";
})(TaxVerificationResult = exports.TaxVerificationResult || (exports.TaxVerificationResult = {}));
var TaxabilityType;
(function (TaxabilityType) {
    TaxabilityType["TAX_RULE"] = "tax_rule";
})(TaxabilityType = exports.TaxabilityType || (exports.TaxabilityType = {}));
var TaxabilityValue;
(function (TaxabilityValue) {
    TaxabilityValue["EXEMPT"] = "exempt";
})(TaxabilityValue = exports.TaxabilityValue || (exports.TaxabilityValue = {}));
var ThreeDSecureCode;
(function (ThreeDSecureCode) {
    ThreeDSecureCode["VERIFIED"] = "verified";
    ThreeDSecureCode["NOT_VERIFIED"] = "not_verified";
    ThreeDSecureCode["FAILED"] = "failed";
})(ThreeDSecureCode = exports.ThreeDSecureCode || (exports.ThreeDSecureCode = {}));
var ThreedsTwoChallengeViewport;
(function (ThreedsTwoChallengeViewport) {
    ThreedsTwoChallengeViewport["XXX_SMALL"] = "xxx_small";
    ThreedsTwoChallengeViewport["XX_SMALL"] = "xx_small";
    ThreedsTwoChallengeViewport["X_SMALL"] = "x_small";
    ThreedsTwoChallengeViewport["SMALL"] = "small";
    ThreedsTwoChallengeViewport["FULLSCREEN"] = "fullscreen";
})(ThreedsTwoChallengeViewport = exports.ThreedsTwoChallengeViewport || (exports.ThreedsTwoChallengeViewport = {}));
var TierAvailability;
(function (TierAvailability) {
    TierAvailability["ALWAYS"] = "always";
    TierAvailability["BACKUP"] = "backup";
})(TierAvailability = exports.TierAvailability || (exports.TierAvailability = {}));
var TierEstimateType;
(function (TierEstimateType) {
    TierEstimateType["CALCULATED"] = "calculated";
    TierEstimateType["CUSTOM"] = "custom";
})(TierEstimateType = exports.TierEstimateType || (exports.TierEstimateType = {}));
var TierStrategy;
(function (TierStrategy) {
    TierStrategy["FASTEST"] = "fastest";
    TierStrategy["LOWEST_COST"] = "lowest_cost";
})(TierStrategy = exports.TierStrategy || (exports.TierStrategy = {}));
var TokenType;
(function (TokenType) {
    TokenType["PERMANENT"] = "permanent";
    TokenType["ONE_TIME"] = "one_time";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var TrackingNumberType;
(function (TrackingNumberType) {
    TrackingNumberType["FLOW"] = "flow";
    TrackingNumberType["CARRIER"] = "carrier";
})(TrackingNumberType = exports.TrackingNumberType || (exports.TrackingNumberType = {}));
var TrackingStatus;
(function (TrackingStatus) {
    TrackingStatus["LABEL_CREATED"] = "label_created";
    TrackingStatus["PENDING"] = "pending";
    TrackingStatus["INFO_RECEIVED"] = "info_received";
    TrackingStatus["PICKED_UP"] = "picked_up";
    TrackingStatus["IN_TRANSIT"] = "in_transit";
    TrackingStatus["OUT_FOR_DELIVERY"] = "out_for_delivery";
    TrackingStatus["ATTEMPT_FAIL"] = "attempt_fail";
    TrackingStatus["DELIVERED"] = "delivered";
    TrackingStatus["EXCEPTION"] = "exception";
    TrackingStatus["RETURNED"] = "returned";
    TrackingStatus["EXPIRED"] = "expired";
    TrackingStatus["UNKNOWN"] = "unknown";
    TrackingStatus["UNMAPPED"] = "unmapped";
})(TrackingStatus = exports.TrackingStatus || (exports.TrackingStatus = {}));
var TradeAgreementName;
(function (TradeAgreementName) {
    TradeAgreementName["USMCA"] = "USMCA";
    TradeAgreementName["T_MEC"] = "T-MEC";
    TradeAgreementName["CUSMA"] = "CUSMA";
    TradeAgreementName["TCA"] = "TCA";
})(TradeAgreementName = exports.TradeAgreementName || (exports.TradeAgreementName = {}));
var TradeAgreementStatus;
(function (TradeAgreementStatus) {
    TradeAgreementStatus["SUPPORTED"] = "supported";
    TradeAgreementStatus["NOT_SUPPORTED"] = "not_supported";
})(TradeAgreementStatus = exports.TradeAgreementStatus || (exports.TradeAgreementStatus = {}));
var TransactionSource;
(function (TransactionSource) {
    TransactionSource["CAPTURE"] = "capture";
    TransactionSource["REFUND"] = "refund";
    TransactionSource["DISPUTE"] = "dispute";
    TransactionSource["ADJUSTMENT"] = "adjustment";
    TransactionSource["REVERSAL"] = "reversal";
    TransactionSource["SHIPPING_LABEL"] = "shipping_label";
    TransactionSource["SHIPPING_LABEL_SERVICE"] = "shipping_label_service";
    TransactionSource["SHIPPING_LABEL_REVENUE_SHARE"] = "shipping_label_revenue_share";
    TransactionSource["TRUEUP"] = "trueup";
    TransactionSource["TRUEUP_BASE"] = "trueup_base";
    TransactionSource["TRUEUP_SURCHARGE"] = "trueup_surcharge";
    TransactionSource["CARRIER_CHARGE"] = "carrier_charge";
    TransactionSource["CARRIER_CHARGE_REVENUE_SHARE"] = "carrier_charge_revenue_share";
    TransactionSource["PLATFORM_FEE"] = "platform_fee";
    TransactionSource["TAX"] = "tax";
    TransactionSource["DUTY"] = "duty";
    TransactionSource["WITHHOLDING"] = "withholding";
    TransactionSource["OTHER_ADJUSTMENT"] = "other_adjustment";
    TransactionSource["TAX_ADJUSTMENT"] = "tax_adjustment";
    TransactionSource["CHANNEL"] = "channel";
    TransactionSource["CHANNEL_BILLED"] = "channel_billed";
    TransactionSource["ORDER_SERVICE"] = "order_service";
    TransactionSource["VIRTUAL_CARD_CAPTURE"] = "virtual_card_capture";
    TransactionSource["VIRTUAL_CARD_REFUND"] = "virtual_card_refund";
    TransactionSource["FAILED_PAYOUT"] = "failed_payout";
    TransactionSource["TAX_REFUND"] = "tax_refund";
    TransactionSource["NON_L_4_L_TAX_DUTY_FX"] = "non_l4l_tax_duty_fx";
    TransactionSource["GE_REVENUE_SHARE"] = "ge_revenue_share";
    TransactionSource["TAX_DUTY_DELTA"] = "tax_duty_delta";
})(TransactionSource = exports.TransactionSource || (exports.TransactionSource = {}));
var TrueupSource;
(function (TrueupSource) {
    TrueupSource["FLOW"] = "flow";
    TrueupSource["CHANNEL"] = "channel";
    TrueupSource["DHL_PARCEL"] = "dhl-parcel";
    TrueupSource["DHL"] = "dhl";
    TrueupSource["UPS"] = "ups";
})(TrueupSource = exports.TrueupSource || (exports.TrueupSource = {}));
var TrueupSurchargeType;
(function (TrueupSurchargeType) {
    TrueupSurchargeType["FUEL"] = "fuel";
    TrueupSurchargeType["REMOTE_AREA"] = "remote_area";
    TrueupSurchargeType["OVERSIZE"] = "oversize";
    TrueupSurchargeType["DUTIES_PAID"] = "duties_paid";
    TrueupSurchargeType["EMERGENCY"] = "emergency";
    TrueupSurchargeType["PEAK"] = "peak";
    TrueupSurchargeType["ADDRESS_CORRECTION"] = "address_correction";
    TrueupSurchargeType["SECURITY"] = "security";
    TrueupSurchargeType["EEI_FILING"] = "eei_filing";
    TrueupSurchargeType["FIXED_DDP"] = "fixed_ddp";
    TrueupSurchargeType["FIXED_CURRENCY_CONVERSION"] = "fixed_currency_conversion";
    TrueupSurchargeType["PROHIBITED_ITEM"] = "prohibited_item";
    TrueupSurchargeType["UNDELIVERABLE_SHIPMENT"] = "undeliverable_shipment";
    TrueupSurchargeType["SIGNATURE_REQUIRED"] = "signature_required";
    TrueupSurchargeType["DIRECT_DELIVERY"] = "direct_delivery";
    TrueupSurchargeType["SATURDAY_STOP"] = "saturday_stop";
    TrueupSurchargeType["RESIDENTIAL_EXTENDED_AREA_PICKUP"] = "residential_extended_area_pickup";
    TrueupSurchargeType["PACKAGE_LEVEL_DETAIL"] = "package_level_detail";
})(TrueupSurchargeType = exports.TrueupSurchargeType || (exports.TrueupSurchargeType = {}));
var UnitOfLength;
(function (UnitOfLength) {
    UnitOfLength["MILLIMETER"] = "millimeter";
    UnitOfLength["CENTIMETER"] = "centimeter";
    UnitOfLength["INCH"] = "inch";
    UnitOfLength["FOOT"] = "foot";
    UnitOfLength["METER"] = "meter";
})(UnitOfLength = exports.UnitOfLength || (exports.UnitOfLength = {}));
var UnitOfMeasurement;
(function (UnitOfMeasurement) {
    UnitOfMeasurement["MILLIMETER"] = "millimeter";
    UnitOfMeasurement["CENTIMETER"] = "centimeter";
    UnitOfMeasurement["INCH"] = "inch";
    UnitOfMeasurement["FOOT"] = "foot";
    UnitOfMeasurement["CUBIC_INCH"] = "cubic_inch";
    UnitOfMeasurement["CUBIC_METER"] = "cubic_meter";
    UnitOfMeasurement["GRAM"] = "gram";
    UnitOfMeasurement["KILOGRAM"] = "kilogram";
    UnitOfMeasurement["METER"] = "meter";
    UnitOfMeasurement["OUNCE"] = "ounce";
    UnitOfMeasurement["POUND"] = "pound";
})(UnitOfMeasurement = exports.UnitOfMeasurement || (exports.UnitOfMeasurement = {}));
var UnitOfTime;
(function (UnitOfTime) {
    UnitOfTime["YEAR"] = "year";
    UnitOfTime["MONTH"] = "month";
    UnitOfTime["WEEK"] = "week";
    UnitOfTime["DAY"] = "day";
    UnitOfTime["HOUR"] = "hour";
    UnitOfTime["MINUTE"] = "minute";
})(UnitOfTime = exports.UnitOfTime || (exports.UnitOfTime = {}));
var UnitOfVolume;
(function (UnitOfVolume) {
    UnitOfVolume["CUBIC_INCH"] = "cubic_inch";
    UnitOfVolume["CUBIC_METER"] = "cubic_meter";
})(UnitOfVolume = exports.UnitOfVolume || (exports.UnitOfVolume = {}));
var UnitOfWeight;
(function (UnitOfWeight) {
    UnitOfWeight["GRAM"] = "gram";
    UnitOfWeight["KILOGRAM"] = "kilogram";
    UnitOfWeight["OUNCE"] = "ounce";
    UnitOfWeight["POUND"] = "pound";
})(UnitOfWeight = exports.UnitOfWeight || (exports.UnitOfWeight = {}));
var UpdatePolicy;
(function (UpdatePolicy) {
    UpdatePolicy["AUTO"] = "auto";
    UpdatePolicy["QUEUE"] = "queue";
    UpdatePolicy["DISCARD"] = "discard";
})(UpdatePolicy = exports.UpdatePolicy || (exports.UpdatePolicy = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "pending";
    UserStatus["ACTIVE"] = "active";
    UserStatus["INACTIVE"] = "inactive";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var ValueAddedService;
(function (ValueAddedService) {
    ValueAddedService["HAZARDOUS_MATERIAL"] = "Hazardous Material";
})(ValueAddedService = exports.ValueAddedService || (exports.ValueAddedService = {}));
var Visibility;
(function (Visibility) {
    Visibility["PUBLIC"] = "public";
    Visibility["PRIVATE"] = "private";
})(Visibility = exports.Visibility || (exports.Visibility = {}));
var WebhookStatus;
(function (WebhookStatus) {
    WebhookStatus["PENDING"] = "pending";
    WebhookStatus["SUCCESS"] = "success";
    WebhookStatus["FAILURE"] = "failure";
    WebhookStatus["IGNORED"] = "ignored";
})(WebhookStatus = exports.WebhookStatus || (exports.WebhookStatus = {}));
var WithholdingDeductionType;
(function (WithholdingDeductionType) {
    WithholdingDeductionType["TAX"] = "tax";
    WithholdingDeductionType["DUTY"] = "duty";
    WithholdingDeductionType["FREIGHT"] = "freight";
    WithholdingDeductionType["INSURANCE"] = "insurance";
})(WithholdingDeductionType = exports.WithholdingDeductionType || (exports.WithholdingDeductionType = {}));
var ZeroAmountIndicator;
(function (ZeroAmountIndicator) {
    ZeroAmountIndicator["ZERO"] = "zero";
    ZeroAmountIndicator["FREE"] = "free";
})(ZeroAmountIndicator = exports.ZeroAmountIndicator || (exports.ZeroAmountIndicator = {}));
